import Images from './index'

export const degreeType = [
    "ABA",
    "Adv. Graduate Cert.",
    "Advanced Certificate",
    "BFA",
    "BMPO",
    "BPhil",
    "BS/MA or BS/MS",
    "Certificate",
    "Diploma",
    "DNP",
    "Dual",
    "Ed.M.",
    "ED.S.",
    "EDS",
    "EdS / M.Ed.",
    "European Masters",
    "GCBU",
    "GCNS",
    "GCSC",
    "GCSE",
    "GCST",
    "GDBZ",
    "GDNS",
    "GDSI",
    "GDST",
    "GEPR",
    "Gr.Dip",
    "GradDip",
    "Graduate Certificate",
    "H.Dip.",
    "HDip",
    "J.D.",
    "J.D. / Master's",
    "J.D./M.A.",
    "JD",
    "JD, Grad.Cert.",
    "JD/MDiv",
    "JD/MPAff",
    "JD/MS",
    "JD/MSCRP",
    "JD/MSSW",
    "LL.M.",
    "LLM/PGDip",
    "LLM/PGDip/PGCert",
    "M.A, M.S",
    "M.A.",
    "M.A. / J.D.",
    "M.A. / M.A.T",
    "M.A. / M.A.T.",
    "M.A. / M.B.A.",
    "M.A. / M.Sc. / M.F.A",
    "M.A. & M.Sc.",
    "M.A. and M.Sc.",
    "M.A./C.A.S.",
    "M.A./M.F.A.",
    "M.A./M.P.H.",
    "M.A./M.Sc./M.Stat.",
    "M.A./PGDip",
    "M.A./PGDiploma",
    "M.A.C.T.M.",
    "M.A/M.Sc.",
    "M.Ap.Stat.",
    "M.Arch. / M.U.D.",
    "M.B.A.",
    "M.B.A./ M.A.",
    "M.B.S.",
    "M.BIOT.",
    "M.Bt.",
    "M.C.S.D.",
    "M.Cat.",
    "M.D",
    "M.DIV.",
    "M.E./M.S.",
    "M.Ec.",
    "M.ED",
    "M.Ed.",
    "M.Eng.",
    "M.Env.Hlth.Sa.",
    "M.F.M.",
    "M.G.I.S.",
    "M.GeoE.",
    "M.H.I.",
    "M.H.S.P.H.",
    "M.I.L.R./M.B.A.",
    "M.I.P.P.",
    "M.I.S",
    "M.I.T.",
    "M.Litt.",
    "M.M.SC.",
    "M.M.U.",
    "M.O.L.",
    "M.P.P",
    "M.P.Th.",
    "M.Phil.",
    "M.R.C.",
    "M.Res",
    "M.Res.",
    "M.S. + MURP",
    "M.S. and M.A.",
    "M.S./Ed.S.",
    "M.S.A.P.S.",
    "M.S.BAE",
    "M.S.Ch.E",
    "M.S.E./MBA",
    "M.S.Ed",
    "M.S.Ed.",
    "M.S.Ed./M.A.T.",
    "M.S.I.SY.E.",
    "M.S.Psy.",
    "M.S.S.",
    "M.Sc",
    "M.Sc / M.A.Sc",
    "M.Sc.",
    "M.Sc. / MAE",
    "M.Sc., M.A.",
    "M.Sc., M.A.Sc.",
    "M.Sc./M.A.Sc",
    "M.Sc./M.B.A.",
    "M.Stat.",
    "M.W.R.",
    "MA - PGDip",
    "MA / Ed.S",
    "MA + MPH",
    "MA by research",
    "MA by Research Law",
    "MA-JD",
    "MA, MFA",
    "MA./PDip",
    "MA(PgCert, PgDip)",
    "MA/ MS",
    "MA/MRES",
    "MA/MSc",
    "MA/MSIS",
    "MA/MSLIS",
    "MA/MSW",
    "MA/PgDip",
    "MA/PgDip/PgCert",
    "MA/Phd",
    "MAAD",
    "MAAP",
    "MAAPDADV",
    "MAAT",
    "MAc",
    "MACC",
    "MAE",
    "MAED",
    "MAEP",
    "MAESC",
    "MAG",
    "MANPS",
    "MANTH",
    "MANTHADV",
    "MAOT",
    "MApCompSc",
    "MAPD",
    "MAPEC",
    "MAppFin",
    "MAppPsy",
    "MARCH",
    "MArch / M.Sc.",
    "MArch / MUP",
    "MArch + MS",
    "MARM/PGDipARM",
    "MASC",
    "MaSS",
    "Master",
    "MAT + MA",
    "MBA / M.Sc.",
    "MBA/MPP",
    "MBA/MS",
    "MBA/MSP",
    "MBAn",
    "MBB",
    "MBinf",
    "MBIOT",
    "MBiotech",
    "MBTSM",
    "MC",
    "MCHMADV",
    "MClin Res",
    "MCMP",
    "MCouns",
    "MCounsel",
    "MCRS",
    "MDDD",
    "MDevStud",
    "MEd/MA",
    "MED/MS",
    "MEEd",
    "MEMgt",
    "MEng/ MASc",
    "MEng/MPAff",
    "MENGRET",
    "MESc",
    "MFA",
    "MFEng",
    "MFIN",
    "MFS",
    "MFT",
    "MGC",
    "MGCS",
    "MGDWS",
    "MGLOBADV",
    "MGlobalScMgmt",
    "MGPS",
    "MHID",
    "MHIS",
    "MHlthPsyc",
    "MHSC",
    "MIDS",
    "MIF",
    "MIPA",
    "MIPP",
    "MIR/JD",
    "MIRAD",
    "MIT/MITM",
    "MITA",
    "MKin",
    "MLaw&amp;Dev",
    "MLitt, MSc",
    "MM / DMA",
    "MMath",
    "MMB",
    "MMECA",
    "MMECAADV",
    "MMed",
    "MMigS",
    "MMLS",
    "MMu",
    "MMUS",
    "MMusEd",
    "MNEUROSC",
    "MOE",
    "MPACC",
    "MPAG",
    "MPC",
    "MPEM",
    "MPetE / MSPetE",
    "MPHE",
    "MPhil / MScR",
    "MPhil, PhD",
    "MPhil/PhD",
    "MPhillEd",
    "MPHM",
    "MPlan",
    "MPols",
    "MPP / MBA",
    "MPP / MSc",
    "MPP/MPH",
    "MProfAcc",
    "MPS, MS",
    "MQE",
    "MRC",
    "MRes",
    "Ms",
    "MS, PhD",
    "MS/ MAEd",
    "MS/MASc",
    "MS/MBA",
    "MS+MBA",
    "MSAM",
    "MSBME",
    "MSc / MEd",
    "MSc / Pg Dip",
    "MSc / PgDip",
    "MSc / PgDip / PgCert",
    "MSc by Dissertation",
    "MSc by Research",
    "MSc or PhD",
    "MSc-PgDip",
    "MSc, PgCert, PgDip",
    "MSc, PGDip",
    "MSc, PgDip, PgCert",
    "MSc, PgDip,PgCert",
    "MSc,PgDip,PgCert",
    "MSc(Res)",
    "MSC/DIP",
    "MSC/LLM",
    "MSc/MEd",
    "MSc/MGPS",
    "MSc/MSCRP",
    "MSc/PDip/PgCert",
    "MSc/PG Cert",
    "MSc/PgCert",
    "MSc/PGCert/PGDip",
    "MSc/PgDip",
    "MSc/PgDip/PgCert",
    "MSc/PGDip/PGCert/CPD",
    "MSc/PGradDip/PGradCe",
    "MSCJ",
    "MScM",
    "MScN",
    "MSCR",
    "MSCRP",
    "MSED",
    "MSEd / MA",
    "MSFM",
    "MSGA",
    "MSGC",
    "MSIS",
    "MSIS/JD",
    "MSIS/MPAff",
    "MSLFS",
    "MSMSE",
    "MSMTE",
    "MSOD",
    "MSSA",
    "MSSW",
    "MST",
    "MStat",
    "MSTSTADV",
    "MSW / CRCJ",
    "MSW / PhD",
    "MSWE",
    "MtchgLn",
    "MUPPD",
    "MURP/JD",
    "NSCBS",
    "PgCert | PgDip | MA",
    "PGCert, PGDip, MSc",
    "PGCert/PGdip/MSc",
    "PGDE",
    "PgDip / PgCert",
    "PGDip/MSc",
    "PGDip/PGCert",
    "PharBE",
    "PhD, MPhil, MScR",
    "PhD/MLitt/MPhil",
    "PhD/MSc by research",
    "PMEG",
    "Postgraduate Certificate",
    "Postgraduate Diploma",
    "Pre-Master",
    "Professional Degree",
    "PsyM.",
    "VAESC",
    "VPLSC",
    "VSCBS",
    "VSCNS",
    "VSCPI",
  ];
  export const monthNames = [
    "January",
    "Febuary",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  export const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  
  export const bachelors = [
    "B.Tech",
    "B.Sc ",
    "B.Eng ",
    "B.IT",
    "BCA",
    "BA",
    "BFA",
    "B.Des",
    "B.Mus",
    "BSW",
    "BBA",
    "B.Com ",
    "B.Acc",
    "B.Fin",
    "BHM",
    "B.Nurs",
    "B.Pharm",
    "BPT",
    "BDS",
    "BHMS",
    "LLB",
    "BSL",
    "B.Ed ",
    "B.P.Ed",
    "B.Sc Ag ",
    "B.Env.Sc",
    "BJMC",
    "BMM",
  
    "other",
  ];
  
  export const bachelorCourses = [
    {
      "Bachelor of Arts (BA)": [
          "Advertising",
          "Anthropology",
          "Archaeology",
          "Business Economics",
          "Cinema Science",
          "Communication Studies",
          "Computer Applications",
          "Criminology",
          "Economics",
          "Education",
          "Entrepreneurship  and  Small Business",
          "Fine Arts",
          "Geography",
          "History",
          "Home Science",
          "Journalism and Mass Communication",
          "Literature",
          "Linguistics",
          "LLB",
          "Mathematics",
          "Music",
          "Philosophy",
          "Physical Education",
          "Political Science",
          "Psychology",
          "Public Administration",
          "Rural Studies",
          "Social Work",
          "Sociology",
          "Statistics",
          "Theology"
      ],
      "Bachelor of Science (BSc)": [
          "Aeronautics",
          "Agriculture",
          "Anatomy",
          "Anesthesia",
          "Animation",
          "Anthropology",
          "Aviation",
          "Biochemistry",
          "Biology",
          "Biotechnology",
          "Botany",
          "Cardiology",
          "Chemistry",
          "Clinical Research",
          "Computer Science",
          "Ecology",
          "Economics",
          "Environmental Science",
          "Fashion Designing",
          "Food Technology",
          "Forestry",
          "Geography",
          "Geology",
          "Healthcare Management",
          "Home Science",
          "Hospitality Management",
          "Information Technology (IT)",
          "Life Sciences",
          "Mathematics",
          "Microbiology",
          "Molecular Biology",
          "Nautical Science",
          "Nursing",
          "Nutrition and Dietetics",
          "Physics",
          "Product Design",
          "Psychology",
          "Radiology",
          "Statistics",
          "Visual Communication",
          "Zoology"
      ],
      "Bachelor of Commerce (BCom)": [
          "Cost accounting",
          "Foreign trade",
          "E-commerce",
          "Business economics/law/finance",
          "Taxation",
          "Marketing",
          "Advertising",
          "Sales management",
          "Office management"
      ],
      "Bachelor of Engg./Tech (BEngg/BTech)": [
          "Aeronautical Engineering",
          "Aerospace Engineering",
          "Applied Electronics & Instrumentation",
          "Agricultural Engineering",
          "Automobile Engg",
          "Bio Chemical Engineering",
          "Bio Medical Engineering",
          "Bio Technology",
          "Bioinformatics",
          "Chemical & Alcohol Technology",
          "Chemical Engineering",
          "Civil Engineering",
          "Computer Science",
          "Computer Science & Engg",
          "Electrical & Electronics Engineering",
          "Electrical Engineering",
          "Electronics & Communication Engineering",
          "Electronics & Instrumentation Engineering",
          "Electronics & Telecomm Engineering",
          "Electronics Engineering",
          "Electronics Instrumentation & Control",
          "Environmental Engineering",
          "Energy Technology",
          "Fire & Safety Engineering",
          "Food Technology",
          "Geo-Informatics Engineering",
          "Geo-Science Engineering",
          "Genetic Engineering",
          "Industrial Engineering",
          "Industrial Production Engineering",
          "Information Technology",
          "Instrumentation & Control",
          "Instrumentation Engineering",
          "Leather Technology",
          "Man Made Fibre Technology",
          "Manufacturing Technology",
          "Marine Engineering",
          "Material Science",
          "Mechanical & Industrial Engineering",
          "Mechanical Engineering",
          "Metallurgical Engineering",
          "Mining Engineering",
          "Mechatronics Engineering",
          "Naval Architecture",
          "Nuclear Science and Engineering",
          "Oil Technology",
          "Ocean Engineering",
          "Paint Technology",
          "Plastic Technology",
          "Production & Industrial Engineering",
          "Production Engineering",
          "Pharmaceutical Technology/B-pharma",
          "Software Engineering",
          "Textile Chemistry",
          "Textile Engineering",
          "Textile Technology",
          "Transportation Engineering"
      ],
      "BMS/BBA/BBS": [
          "Accounting",
          "Airport Capacity Management",
          "Analytics and Big Data",
          "Aviation Management",
          "Big Data Analytics and Mining",
          "Computer Application",
          "Digital Business",
          "Digital Marketing",
          "Digital Media Laws",
          "Entrepreneurship",
          "Events Public Relations and Corporate Communications",
          "Finance",
          "Foreign Trade",
          "Global business management",
          "Green Energy and Sustainability",
          "Green Energy Business",
          "Hospital & Healthcare",
          "Hospitality",
          "Human resource management",
          "Information Systems",
          "Integrated MBA",
          "International Business",
          "International Trade Negotiations",
          "Logistics Management",
          "Marketing",
          "BBA in Marketing and Analytics",
          "Marketing Campaigns and Strategic Communications",
          "Media Management",
          "Oil and Gas Marketing",
          "Oil and Gas Operations",
          "Petroleum Business",
          "Regional Economic Integration",
          "Retail",
          "Service Operations",
          "Services management",
          "Social Media",
          "Sports Management",
          "Supply Chain",
          "Sustainable Development",
          "Tourism management",
          "Travel and Tour Operations"
      ],
      "Bachelor of Law (LLB)": [
          "criminal law",
          "civil law",
          "labor law",
          "international law"
      ],
      "Bachelor of Design (BDes)": [
          "Accessory Design",
          "Animation and VFX",
          "Animation Film Design",
          "Ceramic and Glass Design",
          "Communication Design",
          "Exhibition Design",
          "Fashion Communication & Styling",
          "Fashion Design",
          "Film and Video Communication",
          "Footwear Designs and Production",
          "Furniture and Interior Design",
          "Graphic Design",
          "Industrial Design",
          "Interior Architecture",
          "Knitwear Design",
          "Leather Design",
          "Lifestyle and Accessory Design",
          "Product Design",
          "Textile Design",
          "UX Design",
          "Visual Communication.",
          "Interior Design"
      ],
      "Bachelor of Hotel Management (BHM)": [
          "Hotel Operations Management",
          "Food and Beverage Management",
          "Event Management",
          "Hospitality Marketing",
          "Financial Management for Hospitality",
          "Human Resource Management",
          "Tourism and Travel Management",
          "Culinary Arts"
      ],
      "Bachelor of Pharmacy (BPharm)": [
          "Pharmaceutical Chemistry",
          "Pharmacology",
          "Pharmacognosy",
          "Pharmaceutics",
          "Hospital Pharmacy",
          "Clinical Pharmacy",
          "Regulatory Affairs",
          "Industrial Pharmacy",
          "Community Pharmacy"
      ],
      "Bachelor of Medicine (MBBS)": [
          "Anatomy",
          "Physiology",
          "Biochemistry",
          "Pathology",
          "Pharmacology",
          "Microbiology",
          "Forensic Medicine",
          "Community Medicine",
          "Internal Medicine",
          "Surgery",
          "Pediatrics",
          "Obstetrics and Gynecology",
          "Psychiatry",
          "Dermatology",
          "Ophthalmology",
          "Otorhinolaryngology (ENT)",
          "Anesthesiology",
          "Radiology",
          "Emergency Medicine",
          "Orthopedics",
          "Cardiology",
          "Gastroenterology",
          "Neurology",
          "Nephrology",
          "Pulmonology",
          "Endocrinology",
          "Hematology",
          "Oncology",
          "Rheumatology",
          "Infectious Diseases",
          "Geriatrics",
          "Palliative Care"
      ],
      "Bachelor of Dental Surgery (BDS)": [
          "Oral Anatomy",
          "Oral Physiology",
          "Oral Histology",
          "Oral Pathology",
          "Pharmacology for Dentistry",
          "Microbiology for Dentistry",
          "General Medicine",
          "General Surgery",
          "Oral Medicine and Radiology",
          "Periodontology",
          "Pedodontics (Pediatric Dentistry)",
          "Orthodontics",
          "Prosthodontics",
          "Endodontics",
          "Oral and Maxillofacial Surgery",
          "Conservative Dentistry and Endodontics",
          "Public Health Dentistry",
          "Forensic Odontology",
          "Dental Materials",
          "Oral Implantology",
          "Aesthetic Dentistry",
          "Oral Oncology",
          "Oral Rehabilitation"
      ],
      "Bachelor of Science in Nursing (BSc Nursing)": [
          "Anatomy and Physiology",
          "Nutrition and Dietetics",
          "Microbiology",
          "Biochemistry",
          "Pharmacology",
          "Pathology",
          "Community Health Nursing",
          "Medical-Surgical Nursing",
          "Pediatric Nursing",
          "Obstetrics and Gynecology Nursing",
          "Psychiatric Nursing",
          "Critical Care Nursing",
          "Emergency Nursing",
          "Oncology Nursing",
          "Geriatric Nursing",
          "Rehabilitation Nursing",
          "Nursing Education",
          "Nursing Informatics",
          "Forensic Nursing",
          "Palliative Care Nursing",
          "Public Health Nursing",
          "Occupational Health Nursing",
          "Cardiac Nursing",
          "Neuroscience Nursing",
          "Perioperative Nursing"
      ]
  }
  ]
  
  export const pgCourseList = [
    {
      "Master of Arts (MA)": [
          "Advertising",
          "Anthropology",
          "Archaeology",
          "Business Economics",
          "Cinema Science",
          "Communication Studies",
          "Computer Applications",
          "Criminology",
          "Economics",
          "Education",
          "Entrepreneurship and Small Business",
          "Fine Arts",
          "Geography",
          "History",
          "Home Science",
          "Journalism and Mass Communication",
          "Literature",
          "Linguistics",
          "LLM",
          "Mathematics",
          "Music",
          "Philosophy",
          "Physical Education",
          "Political Science",
          "Psychology",
          "Public Administration",
          "Rural Studies",
          "Social Work",
          "Sociology",
          "Statistics",
          "Theology"
      ],
      "Master of Science (MSc)": [
          "Aeronautics",
          "Agriculture",
          "Anatomy",
          "Anesthesia",
          "Animation",
          "Anthropology",
          "Aviation",
          "Biochemistry",
          "Biology",
          "Biotechnology",
          "Botany",
          "Cardiology",
          "Chemistry",
          "Clinical Research",
          "Computer Science",
          "Ecology",
          "Economics",
          "Environmental Science",
          "Fashion Designing",
          "Food Technology",
          "Forestry",
          "Geography",
          "Geology",
          "Healthcare Management",
          "Home Science",
          "Hospitality Management",
          "Information Technology (IT)",
          "Life Sciences",
          "Mathematics",
          "Microbiology",
          "Molecular Biology",
          "Nautical Science",
          "Nursing",
          "Nutrition and Dietetics",
          "Physics",
          "Product Design",
          "Psychology",
          "Radiology",
          "Statistics",
          "Visual Communication",
          "Zoology"
      ],
      "Master of Commerce (M.Com)": [
          "Cost accounting",
          "Foreign trade",
          "E-commerce",
          "Business economics/law/finance",
          "Taxation",
          "Marketing",
          "Advertising",
          "Sales management",
          "Office management"
      ],
      "Master of Engineering (M.Engg/M.Tech)": [
          "Aeronautical Engineering",
          "Aerospace Engineering",
          "Applied Electronics & Instrumentation",
          "Agricultural Engineering",
          "Automobile Engg",
          "Bio Chemical Engineering",
          "Bio Medical Engineering",
          "Bio Technology",
          "Bioinformatics",
          "Chemical & Alcohol Technology",
          "Chemical Engineering",
          "Civil Engineering",
          "Computer Science",
          "Computer Science & Engg",
          "Electrical & Electronics Engineering",
          "Electrical Engineering",
          "Electronics & Communication Engineering",
          "Electronics & Instrumentation Engineering",
          "Electronics & Telecomm Engineering",
          "Electronics Engineering",
          "Electronics Instrumentation & Control",
          "Environmental Engineering",
          "Energy Technology",
          "Fire & Safety Engineering",
          "Food Technology",
          "Geo-Informatics Engineering",
          "Geo-Science Engineering",
          "Genetic Engineering",
          "Industrial Engineering",
          "Industrial Production Engineering",
          "Information Technology",
          "Instrumentation & Control",
          "Instrumentation Engineering",
          "Leather Technology",
          "Man Made Fibre Technology",
          "Manufacturing Technology",
          "Marine Engineering",
          "Material Science",
          "Mechanical & Industrial Engineering",
          "Mechanical Engineering",
          "Metallurgical Engineering",
          "Mining Engineering",
          "Mechatronics Engineering",
          "Naval Architecture",
          "Nuclear Science and Engineering",
          "Oil Technology",
          "Ocean Engineering",
          "Paint Technology",
          "Plastic Technology",
          "Production & Industrial Engineering",
          "Production Engineering",
          "Pharmaceutical Technology/M.Pharm",
          "Software Engineering",
          "Textile Chemistry",
          "Textile Engineering",
          "Textile Technology",
          "Transportation Engineering"
      ],
      "MMS/MBA/MBS": [
          "Accounting",
          "Airport Capacity Management",
          "Analytics and Big Data",
          "Aviation Management",
          "Big Data Analytics and Mining",
          "Computer Application",
          "Digital Business",
          "Digital Marketing",
          "Digital Media Laws",
          "Entrepreneurship",
          "Events Public Relations and Corporate Communications",
          "Finance",
          "Foreign Trade",
          "Global business management",
          "Green Energy and Sustainability",
          "Green Energy Business",
          "Hospital & Healthcare",
          "Hospitality",
          "Human resource management",
          "Information Systems",
          "Integrated MBA",
          "International Business",
          "International Trade Negotiations",
          "Logistics Management",
          "Marketing",
          "MBA in Marketing and Analytics",
          "Marketing Campaigns and Strategic Communications",
          "Media Management",
          "Oil and Gas Marketing",
          "Oil and Gas Operations",
          "Petroleum Business",
          "Regional Economic Integration",
          "Retail",
          "Service Operations",
          "Services management",
          "Social Media",
          "Sports Management",
          "Supply Chain",
          "Sustainable Development",
          "Tourism management",
          "Travel and Tour Operations"
      ],
      "Master of Law (LLM)": [
          "International Law",
          "Constitutional Law",
          "Criminal Law",
          "Corporate Law",
          "Environmental Law",
          "Intellectual Property Law",
          "Human Rights Law",
          "Tax Law",
          "Labour Law",
          "Family Law",
          "Health Law",
          "Commercial Law",
          "Maritime Law",
          "Banking and Finance Law",
          "European Union Law",
          "Media Law",
          "Arbitration and Dispute Resolution",
          "International Trade Law",
          "Legal Theory"
      ],
      "Master of Medicine (MD)": [
          "Anesthesiology",
          "Dermatology",
          "Emergency Medicine",
          "Family Medicine",
          "Internal Medicine",
          "Neurology",
          "Obstetrics and Gynecology",
          "Ophthalmology",
          "Orthopedic Surgery",
          "Otolaryngology (ENT)",
          "Pediatrics",
          "Psychiatry",
          "Radiology",
          "Surgery",
          "Urology",
          "Cardiology",
          "Endocrinology",
          "Gastroenterology",
          "Hematology",
          "Infectious Diseases",
          "Nephrology",
          "Oncology",
          "Pulmonology",
          "Rheumatology",
          "Sports Medicine",
          "Allergy and Immunology",
          "Geriatrics",
          "Pain Medicine",
          "Physical Medicine and Rehabilitation",
          "Preventive Medicine",
          "Sleep Medicine",
          "Transplantation Medicine"
      ],
      "Master of Dental Surgery (MDS)": [
          "Oral and Maxillofacial Surgery",
          "Orthodontics",
          "Periodontics",
          "Prosthodontics",
          "Endodontics",
          "Pediatric Dentistry",
          "Oral Medicine and Radiology",
          "Oral Pathology",
          "Public Health Dentistry",
          "Forensic Odontology",
          "Oral Implantology",
          "Aesthetic Dentistry",
          "Oral Oncology",
          "Geriatric Dentistry",
          "Dental Materials",
          "Operative Dentistry",
          "Cosmetic Dentistry"
      ],
      "Master of Science in Nursing (MSc Nursing)": [
          "Advanced Nursing Practice",
          "Adult Health Nursing",
          "Community Health Nursing",
          "Geriatric Nursing",
          "Maternal and Child Health Nursing",
          "Mental Health Nursing",
          "Nursing Administration",
          "Nursing Education",
          "Pediatric Nursing",
          "Public Health Nursing",
          "Critical Care Nursing",
          "Emergency Nursing",
          "Oncology Nursing",
          "Orthopedic Nursing",
          "Palliative Care Nursing",
          "Cardiac Nursing",
          "Neuroscience Nursing",
          "Perioperative Nursing",
          "Forensic Nursing",
          "Occupational Health Nursing",
          "Rehabilitation Nursing",
          "School Nursing",
          "Transcultural Nursing",
          "Wound Care Nursing"
      ]
  }
  ]
  
  export const pgCourses = [
    "MA",
    "MSc",
    "MBA",
    "MEng",
    "MEd",
    "MFA",
    "MSW",
    "MPH",
    "MPA",
    "MCA",
    "MTech",
    "LLM",
    "MArch",
    "MDes",
    "MMus",
    "MPhil",
    "MPP",
    "MIR",
    "MOT",
    "MPT",
    "MLIS",
    "MJMC",
    "MHRM",
    "MFin",
    "MSc Economics",
  ];
  // export 
  export const workTypes = [
    { name: "Full time", value: "full-time" },
    { name: "Part time", value: "part-time" },
    { name: "Freelancing", value: "freelancing" },
    { name: "Contract", value: "contract" },
    { name: "Remote", value: "remote" },
    { name: "Flexible", value: "flexible" },
    { name: "Shift work", value: "shift work" },
    { name: "Self employed", value: "self employed" },
    { name: "Internship", value: "internship" },
  
  ];
  export const testScores = [
    {
      name: "Graduate Record Examination",
    scores: [
        [
          {
            description: "Verbal Reasoning",
            count: "",
            range: "130-170",
          },
          {
            description: "Quantitative Reasoning",
            count: "",
            range: "130-170",
          },
          {
            description: "Analytical Writing Assessment",
            count: "",
            range: "1-6",
          },
          {
            description: "Total",
            count: "",
            range: "260-340",
          },
        ],
      ],
      tookTest: "",
    },
    {
      name: "Graduate Management Admission Test",
      scores: [
        [
          {
            description: "Verbal Reasoning",
            count: "",
            range: "6-51",
          },
          {
            description: "Quantitative Reasoning",
            count: "",
            range: "6-51",
          },
          {
            description: "Analytical Writing Assessment",
            count: "",
            range: "1-6",
          },
          {
            description: "Integrated Reasoning",
            count: "",
            range: "1-8",
          },
          {
            description: "Total",
            count: "",
            range: "200-800",
          },
        ],
      ],
      tookTest: "",
    },
    {
      name: "Scholastic Assessment Test",
      scores: [
        [
          {
            description: "Verbal Reasoning",
            count: "",
            range: "130-170",
          },
          {
            description: "Quantitative Reasoning",
            count: "",
            range: "130-170",
          },
          {
            description: "Analytical Writing Assessment",
            count: "",
            range: "1-6",
          },
          {
            description: "Total",
            count: "",
            range: "260-340",
          },
        ],
      ],
      tookTest: "",
    },
    {
      name: "Test of English as a Foreign Language",
      scores: [
        [
          {
            description: "Reading",
            count: "",
            range: "1-30",
          },
          {
            description: "Writing",
            count: "",
            range: "1-30",
          },
          {
            description: "Speaking",
            count: "",
            range: "1-30",
          },
          {
            description: "Listening",
            count: "",
            range: "1-30",
          },
          {
            description: "Total",
            count: "",
            range: "1-120",
          },
        ],
      ],
      tookTest: "",
    },
    {
      name: "International English Language Testing System",
      scores: [
        [
          {
            description: "Reading",
            count: "",
            range: "1-9",
          },
          {
            description: "Writing",
            count: "",
            range: "1-9",
          },
          {
            description: "Speaking",
            count: "",
            range: "1-9",
          },
          {
            description: "Listening",
            count: "",
            range: "1-9",
          },
          {
            description: "Total",
            count: "",
            range: "1-9",
          },
        ],
      ],
      tookTest: "",
    },
    {
      name: "Pearson Test of English",
      scores: [
        [
          {
            description: "Reading",
            count: "",
            range: "10-90",
          },
          {
            description: "Writing",
            count: "",
            range: "10-90",
          },
          {
            description: "Speaking",
            count: "",
            range: "10-90",
          },
          {
            description: "Listening",
            count: "",
            range: "10-90",
          },
          {
            description: "Total",
            count: "",
            range: "10-90",
          },
        ],
      ],
      tookTest: "",
    },
    {
      name: "Duolingo English Test",
      scores: [
        [
          {
            description: "Literacy",
            count: "",
            range: "10-160",
          },
          {
            description: "Conversation",
            count: "",
            range: "10-160",
          },
          {
            description: "Comprehension",
            count: "",
            range: "10-160",
          },
          {
            description: "production",
            count: "",
            range: "10-160",
          },
          {
            description: "Total",
            count: "",
            range: "10-160",
          },
        ],
      ],
      tookTest: "",
    },
    {
      name: "American College Testing",
      scores: [
        [
          {
            description: "English",
            count: "",
            range: "1-36",
          },
          {
            description: "Math",
            count: "",
            range: "1-36",
          },
          {
            description: "Reading",
            count: "",
            range: "1-36",
          },
          {
            description: "Science",
            count: "",
            range: "1-36",
          },
          {
            description: "Total",
            count: "",
            range: "1-36",
          },
        ],
      ],
      tookTest: "",
    },
  ];
  export const plus2 = {
    "Telangana State Board of Intermediate Education": [
      "Mathematics - Physics - Chemistry",
      "Botany - Zoology - Physics - Chemistry ",
      "Mathematics - Economics - Commerce",
      "History - Economics - Civics",
      "History - Geography - Economics",
      "Commerce - Economics - Civics",
      "Commerce - Economics - Geography",
      "Modern Language - History - Civics",
      "Classical Language - History - Civics",
      "Classical Language - Modern Language - History",
      "Modern Language - Economics - History",
      "Modern Language - Economics - Commerce",
      "Commerce - Economics - History",
      "Geography - History - Civics",
      "Public Administration - Economics - Civics",
      "Public Administration - History - Civics",
      "Public Administration - Commerce - Civics",
      "Public Administration - Economics - Commerce",
      "Psychology - Economics - History",
      "History - Geography - Public Administration"
    ]
  
  }
  export const diploma = [
    "Accounting",
    "Business Administration",
    "Computer Science",
    "Criminal Justice",
    "Early Childhood Education",
    "Electrical Engineering Technology",
    "Graphic Design",
    "Healthcare Administration",
    "Hospitality Management",
    "Human Resources Management",
    "Information Technology",
    "Marketing",
    "Mechanical Engineering Technology",
    "Nursing",
    "Paralegal Studies",
    "Pharmacy Technician",
    "Web Development"
  ]
  
  export const diplomaCourses = [
    "Mathematics - Physics - Chemistry",
    "Botany - Zoology - Physics - Chemistry ",
    "Mathematics - Economics - Commerce",
    "History - Economics - Civics",
    "History - Geography - Economics",
    "Commerce - Economics - Civics",
    "Commerce - Economics - Geography",
    "Modern Language - History - Civics",
    "Classical Language - History - Civics",
    "Classical Language - Modern Language - History",
    "Modern Language - Economics - History",
    "Modern Language - Economics - Commerce",
    "Commerce - Economics - History",
    "Geography - History - Civics",
    "Public Administration - Economics - Civics",
    "Public Administration - History - Civics",
    "Public Administration - Commerce - Civics",
    "Public Administration - Economics - Commerce",
    "Psychology - Economics - History",
    "History - Geography - Public Administration",
    "Accounting",
    "Business Administration",
    "Computer Science",
    "Criminal Justice",
    "Early Childhood Education",
    "Electrical Engineering Technology",
    "Graphic Design",
    "Healthcare Administration",
    "Hospitality Management",
    "Human Resources Management",
    "Information Technology",
    "Marketing",
    "Mechanical Engineering Technology",
    "Nursing",
    "Paralegal Studies",
    "Pharmacy Technician",
    "Web Development",
    // Add more diploma courses as needed
  ];
  
  export const disciplines = [
    "Agriculture & Forestry",
    "Applied Sciences & Professions",
    "Arts, Design & Architecture",
    "Business & Management",
    "Computer Science & IT",
    "Education & Training",
    "Engineering & Technology",
    "Environmental Studies & Earth Sciences",
    "Hospitality, Leisure & Sports",
    "Humanities",
    "Journalism & Media",
    "Law",
    "Medicine & Health",
    "Natural Sciences & Mathematics",
    "Social Sciences",
  ];
  
  export const subDisciplines = [
    "Agriculture",
    "Animal Science",
    "Food Technology",
    "Forestry",
    "Horticulture and Crop Science",
    "Marine Science",
    "Aviation Studies",
    "Emergency & Disaster Management",
    "Family & Consumer Science",
    "Fashion, Textiles and Luxury Goods",
    "Food Science",
    "Forensic Science",
    "Library Science",
    "Military Science",
    "Museum Studies",
    "Real Estate & Property Management",
    "Social Work",
    "Architecture",
    "Art and Craft",
    "Art History",
    "Ceramics and Sculpture",
    "Dance",
    "Design",
    "Drama",
    "Fashion Design",
    "Film Studies",
    "Fine Arts",
    "Graphic Design",
    "Industrial Design",
    "Interior Design",
    "Landscape Architecture",
    "Music",
    "Music Composition",
    "Music Performance",
    "Musicology",
    "Painting & Drawing",
    "Photography",
    "Urban Planning",
    "Visual Arts",
    "Accounting",
    "Actuarial Science",
    "Advertising",
    "Agribusiness",
    "Auditing",
    "Banking",
    "Business Administration",
    "Business Intelligence",
    "Commerce",
    "Construction Management",
    "Corporate Communication",
    "Corporate Social Responsibility",
    "Digital Marketing",
    "Digital Media",
    "Engineering Management",
    "Entrepreneurship",
    "Executive MBA",
    "Fashion Management",
    "Finance",
    "Financial Management",
    "Financial Technology",
    "Forensic Accounting",
    "Human Resource Management",
    "Innovation Management",
    "Insurance",
    "International Business",
    "Investment",
    "IT Management",
    "Leadership",
    "Management of Creative Industries",
    "Management Studies",
    "Marketing",
    "Marketing Management",
    "Master in Business Administration (MBA)",
    "Master in Management (MIM)",
    "Operations and Quality Management",
    "Project Management",
    "Public Administration",
    "Retail Management",
    "Risk Management",
    "Strategic Management",
    "Supply Chain Management & Logistics",
    "Taxation",
    "Transport Management",
    "Animation",
    "Artificial Intelligence",
    "Business Information Systems",
    "Computer Sciences",
    "Cyber Security",
    "Data Analytics",
    "Data Science & Big Data",
    "Game Design",
    "Geographical Information Systems (GIS)",
    "Health Informatics",
    "Human Computer Interaction",
    "Information Systems",
    "Information Technology (IT)",
    "Machine Learning",
    "Software Engineering",
    "User Experience Design",
    "Web Technologies & Cloud",
    "Adult Education",
    "Art Education",
    "Coaching",
    "Early Childhood Education",
    "Education",
    "Educational Leadership",
    "Educational Psychology",
    "Educational Research",
    "Health Education",
    "Higher Education",
    "Instructional Design",
    "Literacy Education",
    "Primary Education",
    "School Counselling",
    "Secondary Education",
    "Special Education",
    "STEM Education",
    "Teaching",
    "Teaching English as a Foreign Language",
    "Aerospace Engineering",
    "Automotive Engineering",
    "Bio & Biomedical Engineering",
    "Chemical Engineering",
    "Civil Engineering & Construction",
    "Communications Engineering",
    "Electrical Engineering",
    "Electronics & Embedded Technology",
    "Energy Engineering",
    "Environmental Engineering",
    "General Engineering & Technology",
    "Industrial & Systems Engineering",
    "Marine Engineering",
    "Materials Science",
    "Mechanical Engineering",
    "Mechatronics",
    "Mining, Oil & Gas",
    "Nuclear Engineering",
    "Production and Manufacturing Engineering",
    "Robotics",
    "Sound Engineering",
    "Structural Engineering",
    "Sustainable Energy",
    "Transportation Engineering",
    "Biodiversity & Conservation",
    "Climate Studies & Meteorology",
    "Earth Sciences",
    "Ecology",
    "Environmental Economics & Policy",
    "Environmental Management",
    "Environmental Sciences",
    "Geology",
    "Hydrology & Water Management",
    "Natural Resource Management",
    "Soil Science",
    "Sustainable Development",
    "Toxicology",
    "Culinary Arts",
    "Event Management",
    "Hospitality Management",
    "Sport and Exercise Science",
    "Sports Management",
    "Tourism & Leisure",
    "Ancient History",
    "Christian Studies",
    "Classics",
    "Creative Writing",
    "ESL",
    "Ethics",
    "General Studies",
    "History",
    "Islamic Studies",
    "Language Studies",
    "Liberal Arts",
    "Linguistics",
    "Literature",
    "Modern History",
    "Philosophy",
    "Theology and Religious Studies",
    "Journalism",
    "Media Management",
    "Media Studies & Mass Media",
    "Public Relations",
    "Publishing",
    "Translation & Interpreting",
    "Business Law",
    "Civil & Private Law",
    "Criminal Justice",
    "Criminal Law",
    "European Law",
    "International Law",
    "Legal Studies",
    "Master of Laws (LLM)",
    "Patent & Intellectual Property Law",
    "Public Law",
    "Biomedical Science",
    "Clinical Psychology",
    "Complementary & Alternative Medicine",
    "Dentistry",
    "Epidemiology",
    "Gerontology",
    "Health Administration",
    "Health Sciences",
    "Immunology",
    "Kinesiology",
    "Medical Imaging",
    "Medicine",
    "Midwifery",
    "Nursing",
    "Nutrition & Dietetics",
    "Occupational Health and Safety",
    "Occupational Therapy",
    "Optometry",
    "Pathology",
    "Pharmacy",
    "Physiology",
    "Physiotherapy",
    "Prosthetics and Orthotics",
    "Public Health",
    "Speech Pathology",
    "Veterinary Medicine",
    "Anatomy",
    "Applied Mathematics",
    "Astronomy & Space Sciences",
    "Biochemistry",
    "Bioinformatics & Biostatistics",
    "Biology",
    "Biotechnology",
    "Botany",
    "Chemistry",
    "Computational Mathematics",
    "Financial Mathematics",
    "Genetics",
    "Mathematics",
    "Microbiology",
    "Molecular Sciences",
    "Nanoscience and Nanotechnology",
    "Natural Sciences",
    "Neuroscience",
    "Oceanography",
    "Operations Research",
    "Pharmacology",
    "Physics",
    "Statistics",
    "Zoology",
    "African Studies",
    "American and Australasian studies",
    "Anthropology",
    "Archaeology",
    "Area & Cultural Studies",
    "Art Therapy",
    "Asian Studies",
    "Childhood Studies",
    "Cognitive Science",
    "Communication Studies",
    "Community Development",
    "Counselling Psychology",
    "Criminology",
    "Developmental Psychology",
    "Diplomacy",
    "Econometrics",
    "Economics",
    "Ethnic Studies",
    "European Studies",
    "Forensic Psychology",
    "French Studies",
    "Gender & Sexuality Studies",
    "Geography",
    "German and Scandinavian Studies",
    "Iberian Studies",
    "International Development",
    "International Relations",
    "Italian Studies",
    "Middle Eastern Studies",
    "Organisational Behaviour",
    "Political Science",
    "Psychology",
    "Public Policy",
    "Slavic Studies",
    "Social Policy",
    "Social Psychology",
    "Sociology",
    "Terrorism & Security",
  ];
  export const allowedFileTypes = ['application/pdf', 'image/png', 'image/jpeg'];
  
  export const law = [
    "Business Law",
    "Civil & Private Law",
    "Criminal Justice",
    "Criminal Law",
    "European Law",
    "International Law",
    "Legal Studies",
    "Master of Laws (LLM)",
    "Patent & Intellectual Property Law",
    "Public Law",
  ];
  export const socialScience = [
    "African Studies",
    "American and Australasian studies",
    "Anthropology",
    "Archaeology",
    "Area & Cultural Studies",
    "Art Therapy",
    "Asian Studies",
    "Childhood Studies",
    "Cognitive Science",
    "Communication Studies",
    "Community Development",
    "Counselling Psychology",
    "Criminology",
    "Developmental Psychology",
    "Diplomacy",
    "Econometrics",
    "Economics",
    "Ethnic Studies",
    "European Studies",
    "Forensic Psychology",
    "French Studies",
    "Gender & Sexuality Studies",
    "Geography",
    "German and Scandinavian Studies",
    "Iberian Studies",
    "International Development",
    "International Relations",
    "Italian Studies",
    "Middle Eastern Studies",
    "Organisational Behaviour",
    "Political Science",
    "Psychology",
    "Public Policy",
    "Slavic Studies",
    "Social Policy",
    "Social Psychology",
    "Sociology",
    "Terrorism & Security",
  ];
  export const medicine = [
    "Biomedical Science",
    "Clinical Psychology",
    "Complementary & Alternative Medicine",
    "Dentistry",
    "Epidemiology",
    "Gerontology",
    "Health Administration",
    "Health Sciences",
    "Immunology",
    "Kinesiology",
    "Medical Imaging",
    "Medicine",
    "Midwifery",
    "Nursing",
    "Nutrition & Dietetics",
    "Occupational Health and Safety",
    "Occupational Therapy",
    "Optometry",
    "Pathology",
    "Pharmacy",
    "Physiology",
    "Physiotherapy",
    "Prosthetics and Orthotics",
    "Public Health",
    "Speech Pathology",
    "Veterinary Medicine",
  ];
  export const naturalScience = [
    "Anatomy",
    "Applied Mathematics",
    "Astronomy & Space Sciences",
    "Biochemistry",
    "Bioinformatics & Biostatistics",
    "Biology",
    "Biotechnology",
    "Botany",
    "Chemistry",
    "Computational Mathematics",
    "Financial Mathematics",
    "Genetics",
    "Mathematics",
    "Microbiology",
    "Molecular Sciences",
    "Nanoscience and Nanotechnology",
    "Natural Sciences",
    "Neuroscience",
    "Oceanography",
    "Operations Research",
    "Pharmacology",
    "Physics",
    "Statistics",
    "Zoology",
  ];
  export const hospitality = [
    "Culinary Arts",
    "Event Management",
    "Hospitality Management",
    "Sport and Exercise Science",
    "Sports Management",
    "Tourism & Leisure",
  ];
  export const journalism = [
    "Journalism",
    "Media Management",
    "Media Studies & Mass Media",
    "Public Relations",
    "Publishing",
    "Translation & Interpreting",
  ];
  export const humanity = [
    "Ancient History",
    "Christian Studies",
    "Classics",
    "Creative Writing",
    "ESL",
    "Ethics",
    "General Studies",
    "History",
    "Islamic Studies",
    "Language Studies",
    "Liberal Arts",
    "Linguistics",
    "Literature",
    "Modern History",
    "Philosophy",
    "Theology and Religious Studies",
  ];
  export const education = [
    "Adult Education",
    "Art Education",
    "Coaching",
    "Early Childhood Education",
    "Education",
    "Educational Leadership",
    "Educational Psychology",
    "Educational Research",
    "Health Education",
    "Higher Education",
    "Instructional Design",
    "Literacy Education",
    "Primary Education",
    "School Counselling",
    "Secondary Education",
    "Special Education",
    "STEM Education",
    "Teaching",
    "Teaching English as a Foreign Language",
  ];
  export const environmental = [
    "Biodiversity & Conservation",
    "Climate Studies & Meteorology",
    "Earth Sciences",
    "Ecology",
    "Environmental Economics & Policy",
    "Environmental Management",
    "Environmental Sciences",
    "Geology",
    "Hydrology & Water Management",
    "Natural Resource Management",
    "Soil Science",
    "Sustainable Development",
    "Toxicology",
  ];
  export const engineering = [
    "Aerospace Engineering",
    "Automotive Engineering",
    "Bio & Biomedical Engineering",
    "Chemical Engineering",
    "Civil Engineering & Construction",
    "Communications Engineering",
    "Electrical Engineering",
    "Electronics & Embedded Technology",
    "Energy Engineering",
    "Environmental Engineering",
    "General Engineering & Technology",
    "Industrial & Systems Engineering",
    "Marine Engineering",
    "Materials Science",
    "Mechanical Engineering",
    "Mechatronics",
    "Mining, Oil & Gas",
    "Nuclear Engineering",
    "Production and Manufacturing Engineering",
    "Robotics",
    "Sound Engineering",
    "Structural Engineering",
    "Sustainable Energy",
    "Transportation Engineering",
  ];
  
  export const agriculture = [
    "Agriculture",
    "Animal Science",
    "Food Technology",
    "Forestry",
    "Horticulture and Crop Science",
    "Marine Science",
  ];
  
  export const appliedSciences = [
    "Aviation Studies",
    "Emergency & Disaster Management",
    "Family & Consumer Science",
    "Fashion, Textiles and Luxury Goods",
    "Food Science",
    "Forensic Science",
    "Library Science",
    "Military Science",
    "Museum Studies",
    "Real Estate & Property Management",
    "Social Work",
  ];
  
  export const artsDesign = [
    "Architecture",
    "Art and Craft",
    "Art History",
    "Ceramics and Sculpture",
    "Dance",
    "Design",
    "Drama",
    "Fashion Design",
    "Film Studies",
    "Fine Arts",
    "Graphic Design",
    "Industrial Design",
    "Interior Design",
    "Landscape Architecture",
    "Music",
    "Music Composition",
    "Music Performance",
    "Musicology",
    "Painting & Drawing",
    "Photography",
    "Urban Planning",
    "Visual Arts",
  ];
  export const businessManagement = [
    "Accounting",
    "Actuarial Science",
    "Advertising",
    "Agribusiness",
    "Auditing",
    "Banking",
    "Business Administration",
    "Business Intelligence",
    "Commerce",
    "Construction Management",
    "Corporate Communication",
    "Corporate Social Responsibility",
    "Digital Marketing",
    "Digital Media",
    "Engineering Management",
    "Entrepreneurship",
    "Executive MBA",
    "Fashion Management",
    "Finance",
    "Financial Management",
    "Financial Technology",
    "Forensic Accounting",
    "Human Resource Management",
    "Innovation Management",
    "Insurance",
    "International Business",
    "Investment",
    "IT Management",
    "Leadership",
    "Management of Creative Industries",
    "Management Studies",
    "Marketing",
    "Marketing Management",
    "Master in Business Administration (MBA)",
    "Master in Management (MIM)",
    "Operations and Quality Management",
    "Project Management",
    "Public Administration",
    "Retail Management",
    "Risk Management",
    "Strategic Management",
    "Supply Chain Management & Logistics",
    "Taxation",
    "Transport Management",
  ];
  export const industrySector = [
    { name: "Entertainment", value: "entertainment" },
    { name: "Finance", value: "finance" },
    { name: "Education", value: "education" },
    { name: "Medical", value: "medical" },
    { name: "Information Technology", value: "information technology" },
    { name: "WorkExperience", value: "workExperience" },
    { name: "Textile", value: "textile" },
    { name: "Media And News", value: "media and news" },
    { name: "Food Processing", value: "food processing" },
    { name: "Hospitality", value: "hospitality" },
    {
      name: "Construction And Engineering",
      value: "construction and engineering",
    },
    { name: "Law", value: "law" },
    { name: "Paper", value: "paper" },
    { name: "Real Estate", value: "real estate" },
    { name: "Automobile", value: "automobile" },
    { name: "Aviation", value: "aviation" },
    { name: "Pharmaceutical", value: "pharmaceutical" },
    { name: "Fertilizers", value: "fertilizers" },
    { name: "Advertising", value: "advertising" },
    { name: "Metallurgy", value: "metallurgy" },
    { name: "Energy", value: "energy" },
    { name: "Telecommunications", value: "telecommunications" },
    { name: "Retail", value: "retail" },
    { name: "Manufacturing", value: "manufacturing" },
    { name: "Agriculture", value: "agriculture" },
    { name: "Chemicals", value: "chemicals" },
    {
      name: "Transportation And Logistics",
      value: "transportation and logistics",
    },
    { name: "Consumer Goods", value: "consumer goods" },
    { name: "Healthcare", value: "healthcare" },
  ];
  
  export const computerScience = [
    "Animation",
    "Artificial Intelligence",
    "Business Information Systems",
    "Computer Sciences",
    "Cyber Security",
    "Data Analytics",
    "Data Science & Big Data",
    "Game Design",
    "Geographical Information Systems (GIS)",
    "Health Informatics",
    "Human Computer Interaction",
    "Information Systems",
    "Information Technology (IT)",
    "Machine Learning",
    "Software Engineering",
    "User Experience Design",
    "Web Technologies & Cloud",
  ];
  
  export const skillsList = [
    // "Full Stack Application Development",
    // "Software Development",
    // "Frontend Development",
    // "Backend Development",
    // "Marketing Head",
    "Research Skills",
    "Critical Thinking",
    "Communication Skills",
    "Analytical Skills",
    "Time Management",
    "Adaptability",
    "Teamwork and Collaboration",
    "Problem-Solving",
    "Independent Learning",
    "Ethical and Professional Conduct",
    "Technological Proficiency",
    "Networking Skills",
    "Presentation Skills",
    "Project Management",
    "Leadership",
  ];
  export const universityList = [
    "Abhilashi University,Himachal Pradesh",
    "Academy Of Maritime Education And Training, Tamil Nadu",
    "Academy Of Scientific And Innovative Research,Ghaziabad",
    "Acharya N G Ranga Agricultural University,Hyderabad",
    "Acharya Nagarjuna University,Guntur",
    "Adikavi Nannaya University,Andhra Pradesh",
    "AISECT University, Jharkhand",
    "Ajeenkya DY Patil University,Pune",
    "Alagappa University",
    "Aligarh Muslim University",
    "All India Institute Of Medical Sciences (AIIMS),Delhi",
    "Amity Business School, Noida",
    "Amity University Gurugram",
    "Amity University Jaipur",
    "Amity University Noida",
    "Amity Universiy,Manesar",
    "Amrita Vishwa Vidyapeetham",
    "Andhra University",
    "Anna University",
    "Annamalai University",
    "Anurag Group of Institutions",
    "Apeejay School Of Management ,Delhi",
    "Appejay School Of Marketing,New Delhi",
    "Ashoka University",
    "Assam University",
    "Avinashilingam Institute for Home Science & Higher Education for Women",
    "Baba Farid University Of Health Sciences,Punjab",
    "Babasheb Bhimrao Ambedkar University",
    "Banaras Hindu University",
    "Banasthali Vidyapith",
    "Bangalore University, Bengaluru",
    "Bangalore University,Bengaluru",
    "Barkatullah Vishwavidyalaya,Bhopal",
    "Bengaluru City University,Bangalore",
    "Bhakta Kavi Narsinh Mehta University,Dungarpur",
    "Bharath Institute of Higher Education & Research",
    "Bharathiar University",
    "Bharathidasan University",
    "Bharati Vidyapeeth",
    "Biju Patnaik University Of Technology,Rourkela, Odisha",
    "Birla Institute of Technology",
    "Birla Institute of Technology & Science",
    "Calcutta University",
    "Calicut University",
    "Central Institute Of Fisheries Education,Mumbai",
    "Central University Of Gujarat, Gandhinagar",
    "Central University Of Karnataka,Gulbarga",
    "Central University of Kerala",
    "Central University of Punjab",
    "Central University of Tamil Nadu",
    "Chandigarh University, Chandigarh",
    "Chandigarh University,Mohali",
    "Chaudhary Charan Singh University,Meerut",
    "Chaudhary Devi Lal University,Sirsa",
    "Chettinad Academy of Research and Education",
    "Chitkara University, Rajpura",
    "Christ University,Banglore",
    "Cochin University of Science and Technology",
    "Coimbatore Institute of Technology",
    "College of Engineering Pune",
    "D Y Patil Educational Society",
    "Datta Meghe Institute of Medical Sciences",
    "Dayalbagh Educational Institute",
    "Dayanand Sagar University,Bangluru",
    "Delhi Institute Of Hotel Management & Catering Technology,Delhi",
    "Delhi Technological University",
    "Devi Ahilya Vishwavidyalaya, Indore",
    "Dharmsinh Desai University",
    "Dibrugarh University",
    "DIT University, Mussoorie",
    "Dr APJ Abdul Kalam Technical University, Uttar Pradesh",
    "Dr APJ Abdul Kalam University, Indore",
    "Dr Babasaheb Ambedkar Marathwada University",
    "Dr CV Raman University, Chattisgarh",
    "Dr DY Patil Vidyapeeth",
    "Dr Ntr University Of Health Sciences, Andhra Pradesh",
    "Dr Vishwanath Karad MIT-WPU, Pune",
    "Dr Babasaheb Ambedkar Technological University, Maharashtra",
    "English & Foreign Languages University",
    "Galgotias University, Noida",
    "Gandhi Institute of Technology and Management",
    "Ganpat University, Gujarat",
    "Gauhati University",
    "Gautam Buddh Technical University, Lucknow",
    "Goa University",
    "Gondwana University, Gadchiroli",
    "Government College of Technology",
    "Graphic Era University",
    "Gujarat Technological University",
    "Gujarat University",
    "Guru Gobind Singh Indraprastha University",
    "Guru Jambheshwar University of Science and Technology",
    "Guru Nanak Dev University",
    "Hemchandracharya North Gujarat University, Gujarat",
    "Hemvati Nandan Bahuguna Garhwal University, Srinagar, Uttarakhand",
    "Himachal Pradesh University, Shimla",
    "Himalayan Garhwal University, Uttarakhand",
    "Hindustan Institute Of Technology And Science, New Delhi",
    "Homi Bhabha National Institute",
    "ICFAI Foundation For Higher Education, Hyderabad",
    "IEC University, Himachal Pradesh",
    "IIHMR University, Jaipur",
    "IK Gujral Punjab Technical University, Punjab",
    "Indian Institute of Engineering Science and Technology",
    "Indian Institute Of Management Ahmedabad, Ahmedabad",
    "Indian Institute of Science",
    "Indian Institute of Science Education & Research Bhopal",
    "Indian Institute of Science Education & Research Kolkata",
    "Indian Institute of Science Education & Research Mohali",
    "Indian Institute of Science Education & Research Pune",
    "Indian Institute of Science Education & Research Thiruvananthapuram",
    "Indian Institute of Technology (BHU) Varanasi",
    "Indian Institute of Technology (Indian School of Mines)",
    "Indian Institute of Technology (Others)",
    "Indian Institute of Technology Bhubaneswar",
    "Indian Institute of Technology Bombay",
    "Indian Institute of Technology Delhi",
    "Indian Institute of Technology Gandhinagar",
    "Indian Institute of Technology Guwahati",
    "Indian Institute of Technology Hyderabad",
    "Indian Institute of Technology Indore",
    "Indian Institute of Technology Kanpur",
    "Indian Institute of Technology Kharagpur",
    "Indian Institute of Technology Madras",
    "Indian Institute of Technology Mandi",
    "Indian Institute of Technology Patna",
    "Indian Institute of Technology Roorkee",
    "Indian Institute of Technology Ropar",
    "Indian Institute of Technology Tirupati",
    "Indira Gandhi National Open University, Uttar Pradesh",
    "Indraprastha Institute of Information Technology Delhi",
    "Institute of Chemical Technology",
    "International Institute of Information Technology Hyderabad",
    "Invertis University, Bareilly",
    "Jadavpur University",
    "Jai Narain Vyas University, Jodhpur",
    "Jain University",
    "Jaipur National University, Jaipur",
    "Jamia Hamdard",
    "Jamia Millia Islamia",
    "Jawaharlal Nehru Architecture And Fine Arts University, Hyderabad",
    "Jawaharlal Nehru Technological University",
    "Jawaharlal Nehru University",
    "Jaypee Institute of Information Technology",
    "Jaypee University of Information Technology",
    "Jiwaji University, Gwalior",
    "Jodhpur National University, Jodhpur",
    "JSS Academy of Higher Education and Research",
    "JSS Science and Technology University",
    "Kadi Sarva Vishwavidyalaya, Gujarat",
    "Kakatiya University, Warangal",
    "Kalasalingam Academy of Research and Higher Education",
    "Kalinga Institute of Industrial Technology",
    "Kalinga University, Chhattisgarh",
    "Kalyani University",
    "Kannur University, Kerala",
    "Karnataka University, Dharwad",
    "Karunya Institute of Technology and Sciences",
    "Kerala University",
    "Kerala University Of Health Sciences, Thrissur",
    "King George`s Medical University",
    "KLE Academy of Higher Education and Research",
    "KLE Technological University",
    "Konaseema Institute of Medical Sciences Research Foundation",
    "Koneru Lakshmaiah Education Foundation University",
    "Krishna Institute of Medical Sciences",
    "Krishna University, Andhra Pradesh",
    "Kumaraguru College of Technology",
    "Kumaun University, Uttarakhand",
    "Kurukshetra University",
    "Kuvempu University",
    "Lovely Professional University",
    "M G R Educational and Research Institute",
    "M S Ramaiah University Of Applied Sciences, New Delhi",
    "Madurai Kamaraj University",
    "Maharaja Ganga Singh University, Rajasthan",
    "Maharaja Krishnakumarsinhji Bhavnagar University, Bhavnagar, Gujarat",
    "Maharaja Ranjit Singh Punjab Technical University, Bathinda",
    "Maharaja Sayajirao University of Baroda",
    "Maharashtra University Of Health Sciences, Maharashtra",
    "Maharishi Markandeshwar",
    "Maharshi Dayanand University",
    "Mahatma Gandhi Chitrakoot Gramodaya Vishwavidyalaya, Madhya Pradesh",
    "Mahatma Gandhi University",
    "Mahatma Jyotiba Phule Rohilkhand University, Bareilly",
    "Mahatma Jyotiba Phule Rohilkhand University, Bareilley",
    "Malaviya National Institute of Technology",
    "Manav Rachna International Institute Of Research And Studies, Faridabad",
    "Mangalore University",
    "Manipal Academy of Higher Education",
    "Manipal Institute Of Technology, Manipal",
    "Manipal University Jaipur, Dahmi Kalan",
    "Manipal University, Jaipur",
    "Manipur University",
    "Maulana Abul Kalam Azad University Of Technology, West Bengal",
    "Maulana Azad National Institute of Technology",
    "Meenakshi Academy of Higher Education and Research",
    "Mepco Schlenk Engineering College",
    "Mewar University, Delhi",
    "MGM Institute of Health Sciences",
    "MIT Art, Design And Technology University, Pune",
    "Mizoram University",
    "Mohanlal Sukhadia University, Udaipur",
    "Motilal Nehru National Institute of Technology",
    "Mumbai University",
    "Mysore University",
    "N M A M Institute of Technology",
    "Nagaland University",
    "Nagpur University, Nagpur",
    "Narayana Medical College",
    "Narsee Monjee Institute Of Management Studies, Delhi",
    "National Council For Hotel Management And Catering Technology, Noida",
    "National Institute Of Fashion Technology",
    "National Institute of Industrial Engineering",
    "National Institute of Technology Durgapur",
    "National Institute of Technology Hamirpur",
    "National Institute of Technology Karnataka",
    "National Institute of Technology Patna",
    "National Institute of Technology Raipur",
    "National Institute of Technology Rourkela",
    "National Institute of Technology Silchar",
    "National Institute of Technology Tiruchirappalli",
    "National Institute of Technology Warangal",
    "Nirma University",
    "NITTE",
    "Noorul Islam Centre For Higher Education, Kanyakumari",
    "North Eastern Hill University",
    "OP Jindal Global University",
    "Osmania University",
    "P E S College of Engineering",
    "Padmashree Dr D Y Patil Vidyapeeth",
    "Pandit Bhagwat Dayal Sharma University Of Health Sciences, Rohtak, Haryana",
    "Panjab University",
    "Parul University, Vadodara",
    "Periyar University",
    "PES University",
    "Pondicherry University",
    "Pravara Institute of Medical Sciences",
    "Presidency University",
    "PRIST University, Vallam",
    "PSG College of Technology",
    "PSGR Krishnammal College for Women",
    "Pt Ravishankar Shukla University",
    "Punjab Agricultural University, Ludhiana",
    "Punjabi University",
    "Rabindranath Tagore University",
    "Rajasthan Technical University, Kota",
    "Rajiv Gandhi Proudyogiki Vishwavidyalaya, Madhya Pradesh",
    "Rajiv Gandhi University",
    "Rajiv Gandhi University Of Health Sciences, Bengaluru",
    "Reva University, Bangalore",
    "Reva University, Karnataka",
    "S R M Institute of Science and Technology",
    "Sant Gadge Baba Amravati University, Amravati, Maharashtra",
    "Sardar Patel University, Uttar Pradesh",
    "Sarvepalli Radhakrishnan University, Bhopal",
    "Sathyabama Institute of Science and Technology",
    "Sathyabama University, Chennai",
    "Saurashtra University, Rajkot",
    "Saveetha Institute of Medical and Technical Sciences",
    "Savitribai Phule Pune University",
    "Sawai Man Singh Medical College",
    "Shanmugha Arts Science Technology & Research Academy",
    "Sharda University, Noida",
    "Sharda University, Delhi",
    "Shiv Nadar University",
    "Shivaji University",
    "Shoolini University of Biotechnology and Management Sciences",
    "Shreemati Nathibai Damodar Thackersey Women's University, Mumbai",
    "Shri Mata Vaishno Devi University",
    "Shri Ramdeobaba College of Engineering and Management",
    "Sikkim Manipal University",
    "Siksha `O` Anusandhan",
    "Singhania University, Jhunjunu, Rajasthan",
    "SR Engineering College",
    "Sri Balaji Vidyapeeth Mahatma Gandhi Medical College Campus",
    "Sri Chaitanya Junior College, Ghaziabad",
    "Sri Devraj Urs Academy of Higher Education and Research",
    "Sri Krishna College of Engineering and Technology",
    "Sri Krishna College of Technology",
    "Sri Krishnadevaraya University, Anantapur",
    "Sri Ramachandra Institute of Higher Education And Research",
    "Sri Sairam Engineering College",
    "Sri Sathya Sai Institute of Higher Learning",
    "Sri Satya Sai University Of Technology And Medical Sciences, Madhya Pradesh",
    "Sri Sivasubramaniya Nadar College of Engineering",
    "Sri Venkateswara Institute of Medical Sciences",
    "Sri Venkateswara University",
    "St Xavier's University, Kolkata",
    "SVKM`s Narsee Monjee Institute of Management Studies",
    "Swami Vivekanand Subharti University, Meerut",
    "Symbiosis International",
    "Tata Institute of Social Sciences",
    "Telangana University, Nizamabad",
    "Tezpur University",
    "Thapar Institute of Engineering & Technology",
    "The Gandhigram Rural Institute",
    "The Tamil Nadu Dr MGR Medical University, Chennai",
    "The University of Burdwan",
    "Thiagarajar College of Engineering",
    "Tilka Manjhi Bhagalpur University, Bihar",
    "Tumkur University",
    "University of Delhi",
    "University of Hyderabad",
    "University of Jammu",
    "University of Kashmir",
    "University Of Lucknow, Lucknow",
    "University of Madras",
    "University Of Petroleum And Energy Studies, Dehradun",
    "University Of Petroleum And Energy Studies, Gurugram",
    "University Of Rajasthan, Jaipur",
    "Utkal University",
    "Uttarakhand Technical University, Uttarakhand",
    "Vallurupalli Nageswara Rao Vignana Jyothi Institute of Engineering and Technology",
    "Vardhaman College of Engineering",
    "Veer Bahadur Singh Purvanchal University, Jaunpur",
    "Veer Narmad South Gujarat University, Gujarat",
    "Veer Surendra Sai University of Technology",
    "Vel Tech Rangarajan Dr Sagunthala R & D Institute of Science and Technology",
    "Velagapudi Ramakrishna Siddhartha Engineering College",
    "Vellore Institute of Technology",
    "Vignan University, Andhra Pradesh",
    "Vignan's Foundation for Science, Technology & Research",
    "Vinayaka Mission's Research Foundation",
    "Visva Bharati",
    "Visvesvaraya National Institute Of Technology, Nagpur",
    "Visvesvaraya Technological University",
    "Yenepoya University",
    "Other",
  ];
  export const nationalities = [
    "Afghan",
    "Albanian",
    "Algerian",
    "American",
    "Andorran",
    "Angolan",
    "Antiguan and Barbudan",
    "Argentine",
    "Armenian",
    "Australian",
    "Austrian",
    "Azerbaijani",
    "Bahamian",
    "Bahraini",
    "Bangladeshi",
    "Barbadian",
    "Belarusian",
    "Belgian",
    "Belizean",
    "Beninese",
    "Bhutanese",
    "Bolivian",
    "Bosnian and Herzegovinian",
    "Botswanan",
    "Brazilian",
    "British",
    "Bruneian",
    "Bulgarian",
    "Burkinabé",
    "Burundian",
    "Cambodian",
    "Cameroonian",
    "Canadian",
    "Cape Verdean",
    "Central African",
    "Chadian",
    "Chilean",
    "Chinese",
    "Colombian",
    "Comoran",
    "Congolese (Congo)",
    "Congolese (DRC)",
    "Costa Rican",
    "Croatian",
    "Cuban",
    "Cypriot",
    "Czech",
    "Danish",
    "Djiboutian",
    "Dominican",
    "Dominican (Dominican Republic)",
    "Ecuadorian",
    "Egyptian",
    "Salvadoran",
    "Equatorial Guinean",
    "Eritrean",
    "Estonian",
    "Eswatini",
    "Ethiopian",
    "Fijian",
    "Finnish",
    "French",
    "Gabonese",
    "Gambian",
    "Georgian",
    "German",
    "Ghanaian",
    "Greek",
    "Grenadian",
    "Guatemalan",
    "Guinean",
    "Guinea-Bissauan",
    "Guyanese",
    "Haitian",
    "Honduran",
    "Hungarian",
    "Icelandic",
    "Indian",
    "Indonesian",
    "Iranian",
    "Iraqi",
    "Irish",
    "Israeli",
    "Italian",
    "Ivorian",
    "Jamaican",
    "Japanese",
    "Jordanian",
    "Kazakh",
    "Kenyan",
    "Kiribati",
    "Kuwaiti",
    "Kyrgyz",
    "Lao",
    "Latvian",
    "Lebanese",
    "Lesotho",
    "Liberian",
    "Libyan",
    "Liechtenstein",
    "Lithuanian",
    "Luxembourgish",
    "Macedonian",
    "Malagasy",
    "Malawian",
    "Malaysian",
    "Maldivian",
    "Malian",
    "Maltese",
    "Marshallese",
    "Mauritanian",
    "Mauritian",
    "Mexican",
    "Micronesian",
    "Moldovan",
    "Monacan",
    "Mongolian",
    "Montenegrin",
    "Moroccan",
    "Mozambican",
    "Myanmarian",
    "Namibian",
    "Nauruan",
    "Nepalese",
    "Dutch",
    "New Zealander",
    "Nicaraguan",
    "Nigerien",
    "Nigerian",
    "North Korean",
    "Norwegian",
    "Omani",
    "Pakistani",
    "Palauan",
    "Palestinian",
    "Panamanian",
    "Papua New Guinean",
    "Paraguayan",
    "Peruvian",
    "Philippine",
    "Polish",
    "Portuguese",
    "Qatari",
    "Romanian",
    "Russian",
    "Rwandan",
    "Saint Kitts and Nevis",
    "Saint Lucian",
    "Saint Vincent and the Grenadines",
    "Samoan",
    "San Marino",
    "Sao Tomean",
    "Saudi Arabian",
    "Senegalese",
    "Serbian",
    "Seychellois",
    "Sierra Leonean",
    "Singaporean",
    "Slovak",
    "Slovenian",
    "Solomon Islander",
    "Somali",
    "South African",
    "South Korean",
    "South Sudanese",
    "Spanish",
    "Sri Lankan",
    "Sudanese",
    "Surinamese",
    "Swazi",
    "Swedish",
    "Swiss",
    "Syrian",
    "Taiwanese",
    "Tajik",
    "Tanzanian",
    "Thai",
    "Timorese",
    "Togolese",
    "Tongan",
    "Trinidadian and Tobagonian",
    "Tunisian",
    "Turkish",
    "Turkmen",
    "Tuvaluan",
    "Ugandan",
    "Ukrainian",
    "Emirati",
    "British",
    "American",
    "Uruguayan",
    "Uzbek",
    "Vanuatuan",
    "Venezuelan",
    "Vietnamese",
    "Yemeni",
    "Zambian",
    "Zimbabwean"
  ];
  
  export const currencySymbols = [
    "United Arab Emirates Dirham-AED",
    "Afghan Afghani-AFN",
    "Albanian Lek-ALL",
    "Armenian Dram-AMD",
    "Netherlands Antillean Guilder-ANG",
    "Angolan Kwanza-AOA",
    "Argentine Peso-ARS",
    "Australian Dollar-AUD",
    "Aruban Florin-AWG",
    "Azerbaijani Manat-AZN",
    "Bosnia Herzegovina Convertible Mark-BAM",
    "Barbadian Dollar-BBD",
    "Bangladeshi Taka-BDT",
    "Bulgarian Lev-BGN",
    "Bahraini Dinar-BHD",
    "Burundian Franc-BIF",
    "Bermudian Dollar-BMD",
    "Brunei Dollar-BND",
    "Bolivian Boliviano-BOB",
    "Brazilian Real-BRL",
    "Bahamian Dollar-BSD",
    "Bitcoin-BTC",
    "Bhutanese Ngultrum-BTN",
    "Botswanan Pula-BWP",
    "Belarusian Ruble-BYN",
    "Belize Dollar-BZD",
    "Canadian Dollar-CAD",
    "Congolese Franc-CDF",
    "Swiss Franc-CHF",
    "Chilean Unit of Account (UF)-CLF",
    "Chilean Peso-CLP",
    "Chinese Yuan Offshore-CNH",
    "Chinese Yuan-CNY",
    "Colombian Peso-COP",
    "Costa Rican Colón-CRC",
    "Cuban Convertible Peso-CUC",
    "Cuban Peso-CUP",
    "Cape Verdean Escudo-CVE",
    "Czech Republic Koruna-CZK",
    "Djiboutian Franc-DJF",
    "Danish Krone-DKK",
    "Dominican Peso-DOP",
    "Algerian Dinar-DZD",
    "Egyptian Pound-EGP",
    "Eritrean Nakfa-ERN",
    "Ethiopian Birr-ETB",
    "Euro-EUR",
    "Fijian Dollar-FJD",
    "Falkland Islands Pound-FKP",
    "British Pound Sterling-GBP",
    "Georgian Lari-GEL",
    "Guernsey Pound-GGP",
    "Ghanaian Cedi-GHS",
    "Gibraltar Pound-GIP",
    "Gambian Dalasi-GMD",
    "Guinean Franc-GNF",
    "Guatemalan Quetzal-GTQ",
    "Guyanaese Dollar-GYD",
    "Hong Kong Dollar-HKD",
    "Honduran Lempira-HNL",
    "Croatian Kuna-HRK",
    "Haitian Gourde-HTG",
    "Hungarian Forint-HUF",
    "Indonesian Rupiah-IDR",
    "Israeli New Shekel-ILS",
    "Isle of Man Pound-IMP",
    "Indian Rupee-INR",
    "Iraqi Dinar-IQD",
    "Iranian Rial-IRR",
    "Icelandic Króna-ISK",
    "Jersey Pound-JEP",
    "Jamaican Dollar-JMD",
    "Jordanian Dinar-JOD",
    "Japanese Yen-JPY",
    "Kenyan Shilling-KES",
    "Kyrgystani Som-KGS",
    "Cambodian Riel-KHR",
    "Kuwaiti Dinar-KWD",
    "Cayman Islands Dollar-KYD",
    "Kazakhstani Tenge-KZT",
    "Laotian Kip-LAK",
    "Lebanese Pound-LBP",
    "Sri Lankan Rupee-LKR",
    "Liberian Dollar-LRD",
    "Lesotho Loti-LSL",
    "Libyan Dinar-LYD",
    "Moroccan Dirham-MAD",
    "Moldovan Leu-MDL",
    "Malagasy Ariary-MGA",
    "Macedonian Denar-MKD",
    "Myanma Kyat-MMK",
    "Mongolian Tugrik-MNT",
    "Macanese Pataca-MOP",
    "Mauritanian Ouguiya-MRU",
    "Mauritian Rupee-MUR",
    "Maldivian Rufiyaa-MVR",
    "Malawian Kwacha-MWK",
    "Mexican Peso-MXN",
    "Malaysian Ringgit-MYR",
    "Mozambican Metical-MZN",
    "Namibian Dollar-NAD",
    "Nigerian Naira-NGN",
    "Nicaraguan Córdoba-NIO",
    "Norwegian Krone-NOK",
    "Nepalese Rupee-NPR",
    "New Zealand Dollar-NZD",
    "Omani Rial-OMR",
    "Panamanian Balboa-PAB",
    "Peruvian Nuevo Sol-PEN",
    "Papua New Guinean Kina-PGK",
    "Philippine Peso-PHP",
    "Pakistani Rupee-PKR",
    "Polish Zloty-PLN",
    "Paraguayan Guarani-PYG",
    "Qatari Rial-QAR",
    "Romanian Leu-RON",
    "Serbian Dinar-RSD",
    "Russian Ruble-RUB",
    "Rwandan Franc-RWF",
    "Saudi Riyal-SAR",
    "Solomon Islands Dollar-SBD",
    "Seychellois Rupee-SCR",
    "Sudanese Pound-SDG",
    "Swedish Krona-SEK",
    "Singapore Dollar-SGD",
    "Saint Helena Pound-SHP",
    "Sierra Leonean Leone-SLL",
    "Somali Shilling-SOS",
    "Surinamese Dollar-SRD",
    "South Sudanese Pound-SSP",
    "São Tomé and Príncipe Dobra-STD",
    "São Tomé and Príncipe Dobra (2020)-STN",
    "Salvadoran Colón-SVC",
    "Syrian Pound-SYP",
    "Swazi Lilangeni-SZL",
    "Thai Baht-THB",
    "Tajikistani Somoni-TJS",
    "Turkmenistani Manat-TMT",
    "Tunisian Dinar-TND",
    "Tongan Pa'anga-TOP",
    "Turkish Lira-TRY",
    "Trinidad and Tobago Dollar-TTD",
    "New Taiwan Dollar-TWD",
    "Tanzanian Shilling-TZS",
    "Ukrainian Hryvnia-UAH",
    "Ugandan Shilling-UGX",
    "United States Dollar-USD",
    "Uruguayan Peso-UYU",
    "Uzbekistan Som-UZS",
    "Venezuelan Bolívar Soberano-VES",
    "Vietnamese Dong-VND",
    "Vanuatu Vatu-VUV",
    "Samoan Tala-WST",
    "CFA Franc BEAC-XAF",
    "Silver Ounce-XAG",
    "Gold Ounce-XAU",
    "East Caribbean Dollar-XCD",
    "Special Drawing Rights-XDR",
    "CFA Franc BCEAO-XOF",
    "Palladium Ounce-XPD",
    "CFP Franc-XPF",
    "Platinum Ounce-XPT",
    "Yemeni Rial-YER",
    "South African Rand-ZAR",
    "Zambian Kwacha-ZMW",
    "Zimbabwean Dollar-ZWL",
  ];
  export const countryList = [
    "Australia",
    "Canada",
    "United States of America",
    "United Kingdom",
    "New Zealand",
    "Ireland",
  ];
  
  export const grading = [
    { name: "Percentage", value: "percentage" },
    { name: "CGPA", value: "cgpa" },
    { name: "GPA", value: "gpa" },
    { name: "Grade", value: "grade" },
  ];
  
  export const statusList = [
    "Waiting For Counsellor's Approval",
    "Counsellor Approved",
    "Counsellor Disapproved",
    "Request Received",
    "Document checklist",
    "Documents verification",
    "Application form draft",
    "Submission",
    "Pending Checklists",
    "Waiting for Decision",
    "Conditional Acceptance",
    "Result Received",
    "Financial Documents",
    "I20 Request",
    "I20 Received",
  ];
  
  export const disciplineList = [
   {
     name : "Business & Management",
     options:[
      "Business Administration"	,
      "Business Intelligence",
      "Executive MBA",
      "Entrepreneurship",
      "Supply Chain Management & Logistics"
     ]
   } ,
   {
    name : "Computer Science & IT",
    options:[
      
      "Artificial Intelligence",
      "Computer Sciences",
      "Information Technology (IT)",
     "Cyber Security",
      "Software Engineering"
    ]
  } ,
  {
    name : "Engineering & Technology",
    options:[
     "Electrical Engineering"	,
     "Civil Engineering & Construction",
     "Electronics & Embedded Technology",
     "Mechanical Engineering",
     "Robotics"
    ]
  } ,
  {
    name : "Arts, Design & Architecture",
    options:[
     "Architecture"	,
     "Fashion Design",
     "Interior Design",
     "Film Studies",
     "Music"
    ]
  } ,
  {
    name : "Medicine & Health",
    options:[
     "Clinical Psychology"	,
     "Health Administration",
     "Pharmacy",
     "Public Health",
     "Biomedical Science"
    ]
  } ,
  
  ]
  
  export const destinationList = {
    "United States of America": {
      Arizona: [
        "Flagstaff",
        "Tucson",
        "Tempe",
        "Phoenix",
        "Tempe Junction",
        "Mesa",
        "Peoria",
        "Glendale",
        "Florence",
        "Prescott",
      ],
      Ohio: [
        "Cincinnati",
        "Dayton",
        "Oxford",
        "Cleveland",
        "Columbus",
        "Kent",
        "Athens",
        "Youngstown",
        "Bowling Green",
        "Ada",
        "Tiffin",
        "Yellow Springs",
        "Ashland",
        "Findlay",
        "University Heights",
        "Springfield",
        "Berea",
        "North Canton",
        "Portsmouth",
        "Akron",
        "Westerville",
        "Steubenville",
        "Rootstown",
        "Cedarville",
        "Hiram",
        "Toledo",
        "Marietta",
        "Rio Grande",
        "Bluffton",
        "Logan",
        "Cleveland Heights",
        "Oregon",
        "Riverside",
        "Reading",
        "Dublin",
        "Oberlin",
      ],
      "South Carolina": [
        "Columbia",
        "Clemson",
        "Orangeburg",
        "Charleston",
        "Conway",
        "Greenville",
        "Rock Hill",
        "Greenwood",
        "Spartanburg",
        "Anderson",
        "Aiken",
        "Florence",
        "Clinton",
        "Central",
      ],
      Massachusetts: [
        "Cambridge",
        "Worcester",
        "Boston",
        "Medford",
        "North Dartmouth",
        "Amherst",
        "Lowell",
        "North Andover",
        "Springfield",
        "Bridgewater",
        "Westfield",
        "Chestnut Hill",
        "Buzzards Bay",
        "Framingham",
        "Waltham",
        "Northampton",
        "Salem",
        "Longmeadow",
        "Beverly",
        "Williamstown",
        "Fitchburg",
        "Wenham",
        "Weston",
        "North Adams",
        "Newton",
        "South Hadley",
        "Haverhill",
        "Chicopee",
        "Dudley",
        "Babson Park",
        "Brookline",
        "Milton",
        "Amherst Center",
        "East Longmeadow",
        "Andover",
        "Adams",
        "Barnstable",
        "Easthampton",
      ],
      "New York": [
        "Troy",
        "Ithaca",
        "Brooklyn",
        "Syracuse",
        "Rochester",
        "New York City",
        "Valhalla",
        "Albany",
        "Old Westbury",
        "Stony Brook",
        "Alfred",
        "Riverdale",
        "Potsdam",
        "Hempstead",
        "New Paltz",
        "Throggs Neck",
        "The Bronx",
        "Queens",
        "Sparkill",
        "Garden City",
        "Keuka Park",
        "Bronxville",
        "Annandale-on-Hudson",
        "Oswego",
        "Elmira",
        "Purchase",
        "Cortland",
        "Buffalo",
        "Brookville",
        "Newburgh",
        "Poughkeepsie",
        "Utica",
        "Hamilton",
        "Vestal",
        "Loudonville",
        "Geneseo",
        "Canton",
        "Brockport",
        "Saratoga Springs",
        "Niagara University",
        "Dobbs Ferry",
        "Oneonta",
        "Staten Island",
        "Plattsburgh",
        "Fredonia",
        "Manhattan",
        "Binghamton",
        "Monroe",
        "Hornell",
        "Pleasantville",
        "Harrison",
        "Sleepy Hollow",
      ],
      California: [
        "San Diego",
        "Long Beach",
        "Santa Clara",
        "Stanford",
        "Los Angeles",
        "Davis",
        "San Francisco",
        "Claremont",
        "Irvine",
        "Santa Cruz",
        "Berkeley",
        "Riverside",
        "Northridge",
        "Merced",
        "Fresno",
        "Sacramento",
        "Fullerton",
        "Santa Barbara",
        "Rohnert Park",
        "Stockton",
        "Carson",
        "Monterey",
        "Pasadena",
        "Hayward",
        "Seaside",
        "Turlock",
        "La Verne",
        "La Jolla",
        "Orange",
        "Loma Linda",
        "San Bernardino",
        "San Rafael",
        "San Marcos",
        "Arcata",
        "Azusa",
        "Bakersfield",
        "Malibu",
        "Chico",
        "Burbank",
        "Moraga",
        "Redlands",
        "Aliso Viejo",
        "Camarillo",
        "Thousand Oaks",
        "La Mirada",
        "Santa Clarita",
        "San Jose",
        "Atherton",
        "Rosemead",
        "Costa Mesa",
        "Redding",
        "San Luis Obispo",
        "Valencia",
        "Pomona",
        "Beverly Hills",
        "Malibu Beach",
        "Home Gardens",
        "Oakland",
        "Poway",
        "Pittsburg",
      ],
      Indiana: [
        "Notre Dame",
        "Indianapolis",
        "West Lafayette",
        "Terre Haute",
        "Gary",
        "Fort Wayne",
        "Hammond",
        "New Albany",
        "Valparaíso",
        "Evansville",
        "Bloomington",
        "South Bend",
        "Muncie",
        "Goshen",
        "Marion",
        "Richmond",
        "Upland",
        "Anderson",
        "Winona Lake",
        "Kokomo",
        "North Manchester",
        "Valparaiso",
        "Michigan City",
        "Washington",
      ],
      Kansas: [
        "Lawrence",
        "Wichita",
        "Manhattan",
        "Pittsburg",
        "Topeka",
        "Emporia",
        "Hays",
        "Baldwin City",
        "Leavenworth",
        "Kansas City",
        "Newton",
        "Arkansas City",
      ],
      Illinois: [
        "Chicago",
        "Normal",
        "Champaign",
        "Evanston",
        "DeKalb",
        "Peoria",
        "Romeoville",
        "Charleston",
        "Carbondale",
        "Macomb",
        "Springfield",
        "Joliet",
        "Lebanon",
        "Lisle",
        "Rockford",
        "Lake Forest",
        "Naperville",
        "Edwardsville",
        "River Forest",
        "Wheaton",
        "Deerfield",
        "Aurora",
        "Decatur",
        "North Chicago",
        "Rock Island",
        "Urbana",
        "Wheeling",
        "Oswego",
        "Moline",
        "Greenville",
      ],
      Texas: [
        "College Station",
        "Houston",
        "Arlington",
        "Victoria",
        "Denton",
        "Stephenville",
        "Lubbock",
        "San Marcos",
        "San Antonio",
        "Dallas",
        "Prairie View",
        "Beaumont",
        "Kingsville",
        "Tyler",
        "Longview",
        "Fort Worth",
        "Canyon",
        "Corpus Christi",
        "Galveston",
        "Waco",
        "Nacogdoches",
        "Huntsville",
        "San Angelo",
        "Abilene",
        "Irving",
        "Keene",
        "Laredo",
        "Austin",
        "Belton",
        "Wichita Falls",
        "Texarkana",
        "Edinburg",
        "Odessa",
        "Richardson",
        "El Paso",
        "Marshall",
        "Texas City",
        "Webster",
        "Helotes",
        "Commerce",
        "Decatur",
        "Missouri City",
      ],
      "District of Columbia": ["Washington", "Fort Lesley J McNair"],
      Michigan: [
        "Detroit",
        "Kalamazoo",
        "Ann Arbor",
        "Dearborn",
        "Southfield",
        "East Lansing",
        "Houghton",
        "Ypsilanti",
        "Rochester Hills",
        "University Center",
        "Big Rapids",
        "Mount Pleasant",
        "Allendale",
        "Flint",
        "Livonia",
        "Berrien Springs",
        "Marquette",
        "Grand Rapids",
        "Troy",
        "Midland",
        "Fair Plain",
        "Highland Park",
      ],
      Florida: [
        "Orlando",
        "Gainesville",
        "Daytona Beach",
        "Melbourne",
        "Coral Gables",
        "Tallahassee",
        "Boca Raton",
        "Miami",
        "Tampa",
        "Jacksonville",
        "Fort Lauderdale",
        "DeLand",
        "Pensacola",
        "Babson Park",
        "Fort Myers",
        "Lakeland",
        "West Palm Beach",
        "St. Augustine",
        "Saint Leo",
        "Winter Park",
        "Hialeah",
        "Springfield",
        "Florida City",
        "Jacksonville Beach",
        "Davie",
        "North Miami",
        "Memphis",
        "Sarasota",
        "Fort Myers Beach",
      ],
      Missouri: [
        "St. Louis",
        "Rolla",
        "Kansas City",
        "St. Charles",
        "Cape Girardeau",
        "Springfield",
        "Warrensburg",
        "Maryville",
        "Parkville",
        "Kirksville",
        "Marshall",
        "Columbia",
        "St. Joseph",
        "Chesterfield",
        "Saint Louis",
        "Pacific",
        "Webster Groves",
        "Saint Charles",
        "Washington",
        "Jefferson City",
      ],
      "New Jersey": [
        "Hoboken",
        "Princeton",
        "Glassboro",
        "Newark",
        "Teaneck",
        "Montclair",
        "Galloway",
        "West Long Branch",
        "Union",
        "South Orange",
        "Mahwah",
        "Lawrenceville",
        "Ewing",
        "Madison",
        "Morristown",
        "New Brunswick",
        "Jersey City",
        "Wayne",
        "Ocean Acres",
        "Elizabeth",
        "Camden",
        "Passaic",
        "Ramsey",
      ],
      Colorado: [
        "Boulder",
        "Fort Collins",
        "Denver",
        "Golden",
        "Pueblo",
        "Grand Junction",
        "Gunnison",
        "Greeley",
        "Durango",
        "Lakewood",
        "Colorado Springs",
        "Frederick",
      ],
      "New Mexico": ["Las Cruces", "Socorro", "Las Vegas", "Albuquerque"],
      "North Carolina": [
        "Raleigh",
        "Greenville",
        "Winston-Salem",
        "Greensboro",
        "High Point",
        "Durham",
        "Charlotte",
        "Chapel Hill",
        "Boone",
        "Elon",
        "Wilmington",
        "Fayetteville",
        "Misenheimer",
        "Cullowhee",
        "Buies Creek",
        "Pembroke",
        "Mars Hill",
        "Laurinburg",
        "Wingate",
        "Montreat",
        "Nashville",
        "Carolina Beach",
        "Albemarle",
        "Asheville",
        "Lumberton",
      ],
      Oklahoma: [
        "Stillwater",
        "Edmond",
        "Weatherford",
        "Oklahoma City",
        "Tahlequah",
        "Norman",
        "Langston",
        "Lawton",
        "Tulsa",
        "Bethany",
        "Claremore",
      ],
      Alabama: [
        "Auburn",
        "Huntsville",
        "Tuscaloosa",
        "Mobile",
        "Tuskegee",
        "Jacksonville",
        "Florence",
        "Birmingham",
        "Montgomery",
        "Troy",
        "Montevallo",
        "Livingston",
        "Oxford",
        "Madison",
        "Russellville",
        "Oneonta",
      ],
      Minnesota: [
        "Mankato",
        "Saint Paul",
        "Moorhead",
        "Minneapolis",
        "Winona",
        "Marshall",
        "Bemidji",
        "St. Cloud",
        "Saint Cloud",
        "Duluth",
        "Fairfax",
        "Rochester",
        "Plymouth",
      ],
      Mississippi: [
        "Mississippi State",
        "University",
        "Hattiesburg",
        "Jackson",
        "Clinton",
        "Cleveland",
        "Columbus",
        "Lorman",
        "Starkville",
        "West Hattiesburg",
        "Philadelphia",
        "Winona",
        "Columbia",
        "Meridian",
      ],
      Pennsylvania: [
        "Pittsburgh",
        "University Park",
        "Philadelphia",
        "Bethlehem",
        "Erie",
        "Wilkes-Barre",
        "Villanova",
        "Lewisburg",
        "Millersville",
        "Chester",
        "Latrobe",
        "Shippensburg",
        "Indiana",
        "Scranton",
        "Reading",
        "Bryn Mawr",
        "Allentown",
        "Glenside",
        "Bloomsburg",
        "St. Davids",
        "Elizabethtown",
        "Kutztown",
        "Rosemont",
        "Lincoln University",
        "Mechanicsburg",
        "Beaver Falls",
        "East Stroudsburg",
        "Moon Township",
        "Greensburg",
        "Elkins Park",
        "Clarks Summit",
        "Langhorne",
        "Harrisburg",
        "West Chester",
        "Selinsgrove",
        "Loretto",
        "California",
        "Slippery Rock",
        "Annville",
        "Lock Haven",
        "York",
        "Williamsport",
        "Edinboro",
        "Clarion",
        "Middletown",
        "Ardmore",
        "Grove City",
        "Hershey",
        "Huntingdon",
        "Montgomeryville",
        "New Castle",
        "Carlisle",
        "Paoli",
      ],
      "West Virginia": [
        "Morgantown",
        "Huntington",
        "Institute",
        "Fairmont",
        "West Liberty",
        "Shepherdstown",
        "Philippi",
        "Athens",
        "Bethany",
        "Charleston",
      ],
      Georgia: [
        "Atlanta",
        "Athens",
        "Macon",
        "Kennesaw",
        "Statesboro",
        "Savannah",
        "Columbus",
        "Carrollton",
        "Valdosta",
        "Dahlonega",
        "Augusta",
        "Lookout Mountain",
        "Decatur",
        "Morrow",
        "Milledgeville",
        "Gainesville",
        "Doraville",
        "Lawrenceville",
        "Marietta",
        "Martinez",
      ],
      Tennessee: [
        "Chattanooga",
        "Knoxville",
        "Nashville",
        "Harrogate",
        "Memphis",
        "Cookeville",
        "Murfreesboro",
        "Johnson City",
        "Cleveland",
        "Lebanon",
        "Jefferson City",
        "Jackson",
        "Tullahoma",
        "Springfield",
        "Lakeland",
      ],
      "North Dakota": ["Grand Forks", "Fargo", "Minot"],
      Kentucky: [
        "Lexington",
        "Louisville",
        "Morehead",
        "Bowling Green",
        "Murray",
        "Richmond",
        "Highland Heights",
        "Frankfort",
        "Midway",
        "Lexington-Fayette",
      ],
      Virginia: [
        "Norfolk",
        "Fairfax",
        "Richmond",
        "Charlottesville",
        "Lynchburg",
        "Virginia Beach",
        "Williamsburg",
        "Radford",
        "Petersburg",
        "Arlington",
        "Farmville",
        "Harrisonburg",
        "Newport News",
        "Roanoke",
        "Hampton",
        "Winchester",
        "Bridgewater",
        "Blacksburg",
        "Fredericksburg",
        "Manassas",
      ],
      Connecticut: [
        "West Haven",
        "Fairfield",
        "New Haven",
        "New Britain",
        "Bridgeport",
        "Storrs",
        "West Hartford",
        "Hamden",
        "Danbury",
        "Middletown",
        "Cromwell",
        "Hartford",
      ],
      Nevada: ["Reno", "Las Vegas", "Winchester"],
      "New Hampshire": [
        "Hanover",
        "Durham",
        "Plymouth",
        "Henniker",
        "Manchester",
        "Keene",
        "Weare",
      ],
      Utah: [
        "Logan",
        "Provo",
        "Ogden",
        "Cedar City",
        "Orem",
        "St. George",
        "Salt Lake City",
        "Saint George",
      ],
      Maryland: [
        "College Park",
        "Baltimore",
        "Towson",
        "Princess Anne",
        "Frostburg",
        "Westminster",
        "Frederick",
        "Salisbury",
        "Takoma Park",
        "California",
        "Baltimore Highlands",
        "Langley Park",
        "Maryland City",
        "Chevy Chase",
      ],
      Wisconsin: [
        "Madison",
        "Milwaukee",
        "River Falls",
        "Menomonie",
        "La Crosse",
        "Oshkosh",
        "Green Bay",
        "Whitewater",
        "Stevens Point",
        "Mequon",
        "Eau Claire",
        "Waukesha",
        "Kenosha",
        "Ashland",
        "Evansville",
        "Menominee",
        "Somers",
      ],
      Nebraska: [
        "Omaha",
        "Lincoln",
        "Bellevue",
        "Chadron",
        "Crete",
        "Wayne",
        "Hastings",
        "Kearney",
        "Fremont",
        "Nebraska City",
      ],
      Louisiana: [
        "Baton Rouge",
        "New Orleans",
        "Lafayette",
        "Lake Charles",
        "Ruston",
        "Thibodaux",
        "Monroe",
        "Hammond",
        "Shreveport",
        "Abbeville",
      ],
      Oregon: [
        "Corvallis",
        "Portland",
        "Klamath Falls",
        "Eugene",
        "Salem",
        "Newberg",
        "Ashland",
        "Monmouth",
        "La Grande",
        "Forest Grove",
        "Dallas",
      ],
      Montana: ["Bozeman", "Missoula", "Billings", "Butte"],
      Washington: [
        "Seattle",
        "Pullman",
        "Lacey",
        "Bellingham",
        "Ellensburg",
        "Spokane",
        "Tacoma",
        "Kirkland",
        "Cheney",
        "Olympia",
        "Kenmore",
      ],
      "South Dakota": [
        "Vermillion",
        "Rapid City",
        "Brookings",
        "Aberdeen",
        "Spearfish",
        "Sioux Falls",
        "Madison",
      ],
      Arkansas: [
        "Fayetteville",
        "Jonesboro",
        "Russellville",
        "Little Rock",
        "Pine Bluff",
        "Magnolia",
        "Conway",
        "Siloam Springs",
        "Searcy",
        "Arkadelphia",
      ],
      Iowa: [
        "Ames",
        "Des Moines",
        "Cedar Falls",
        "Fairfield",
        "Dubuque",
        "Iowa City",
        "Davenport",
        "Sioux Center",
      ],
      Delaware: ["Newark", "Dover", "New Castle", "Wilmington"],
      "Rhode Island": [
        "Providence",
        "Kingston",
        "Bristol",
        "Newport",
        "Smithfield",
        "East Greenwich",
        "North Smithfield",
        "North Providence",
      ],
      Hawaii: ["Honolulu", "Hilo"],
      Idaho: ["Moscow", "Pocatello", "Boise", "Nampa", "Idaho Falls"],
      Wyoming: ["Laramie"],
      Alaska: ["Fairbanks", "Anchorage", "Juneau"],
      Maine: ["Orono", "Bangor", "Portland", "Biddeford", "Gorham"],
      Vermont: ["Plainfield", "Colchester", "Burlington"],
      "Washington, D.C.": ["Washington, D. C."],
    },
    Australia: {
      "New South Wales": [
        "Sydney",
        "Penrith",
        "Wollongong",
        "Bathurst",
        "Lismore",
        "North Sydney",
        "Armidale",
        "Callaghan",
        "Paramatta",
        "Camperdown",
        "Paddington, Sydney, NSW",
        "Newcastle",
        "Kensington",
        "Albury",
        "Lugarno",
      ],
      "Western Australia": [
        "Crawley",
        "Perth",
        "Murdoch",
        "Joondalup",
        "Fremantle",
      ],
      Victoria: [
        "Clayton",
        "Melbourne",
        "Geelong",
        "Ballarat",
        "Hawthorn",
        "Caulfield North",
        "Bendigo",
      ],
      "South Australia": ["Adelaide"],
      Queensland: [
        "Toowoomba",
        "Gold Coast",
        "Brisbane",
        "Sippy Downs",
        "Townsville",
        "St Lucia",
        "Buderim",
        "Cairns",
        "Bilinga",
        "Gatton",
        "Springfield Central",
      ],
      "Australian Capital Territory": ["Canberra"],
      "Northern Territory": ["Darwin"],
      Tasmania: ["Hobart", "Launceston"],
    },
    Canada: {
      "British Columbia": [
        "Burnaby",
        "Victoria",
        "Prince George",
        "Nanaimo",
        "Abbotsford",
        "Vancouver",
        "Langley",
        "Kamloops",
      ],
      Ontario: [
        "Toronto",
        "Ottawa",
        "Hamilton",
        "Waterloo",
        "Windsor",
        "Kingston",
        "Sudbury",
        "Thunder Bay",
        "St. Catharines",
        "Oshawa",
        "Peterborough",
        "Guelph",
        "North Bay",
        "London",
      ],
      Alberta: ["Edmonton", "Calgary", "Lethbridge"],
      "Nova Scotia": ["Halifax", "Wolfville"],
      Saskatchewan: ["Saskatoon", "Regina"],
      Quebec: ["Montréal", "Sherbrooke", "Quebec City"],
      Manitoba: ["Winnipeg", "Brandon"],
      "New Brunswick": ["Fredericton"],
      "Newfoundland and Labrador": ["St John’s"],
      "Prince Edward Island": ["Charlottetown"],
      other: [
        "Winnipeg",
        "Saskatoon",
        "Lethbridge",
        "Ottawa",
        "Victoria",
        "Greater Sudbury",
        "Thunder Bay",
        "Terrace",
        "Montréal",
        "London",
        "Fredericton",
        "Halifax",
        "Edmonton",
        "Toronto",
        "Guelph",
        "Vancouver",
        "St. John's",
        "Burnaby",
        "Kingston",
        "Hamilton",
        "Regina",
        "Calgary",
        "Nanaimo",
        "Waterloo",
        "Oshawa",
        "St. Catharines",
        "Brantford",
        "Mississauga",
        "Windsor",
        "City of Langley",
        "Kelowna",
        "Sydney",
        "Brandon",
        "Charlottetown",
        "Antigonish",
        "Sackville",
        "Prince George",
        "Saint John",
        "North Bay",
        "Sherbrooke",
      ],
    },
    "New Zealand": {
      Waikato: ["Hamilton"],
      Auckland: ["Auckland"],
      "Manawatu-Wanganui": ["Palmerston North"],
      Wellington: ["Wellington"],
      Canterbury: ["Christchurch", "Lincoln"],
      Otago: ["Dunedin"],
      other: [
        "Wellington",
        "Dunedin",
        "Christchurch",
        "Hamilton",
        "Auckland",
        "Palmerston North",
        "North Shore",
      ],
    },
    Ireland: {
      "County Galway": ["Galway"],
      "County Limerick": ["Limerick"],
      "County Dublin": ["Dublin", "Dún Laoghaire"],
      "County Cork": ["Cork", "Bishopstown"],
      "County Kildare": ["Maynooth"],
      "County Louth": ["Dundalk"],
      "County Carlow": ["Carlow"],
      other: [
        "Limerick",
        "Maynooth",
        "Dublin",
        "Cork",
        "Waterford",
        "Galway",
        "Sligo",
        "Dún Laoghaire",
      ],
      "N Ireland": ["Dublin"],
    },
    "United Kingdom": {
      "Yorkshire and the Humber": [
        "Sheffield",
        "Leeds",
        "Huddersfield",
        "Bradford",
        "Hull",
        "York",
      ],
      "East of England": [
        "Cranfield",
        "Hatfield",
        "Luton",
        "Cambridge",
        "Lincoln",
        "Colchester",
        "Norwich",
        "Chelmsford",
        "Ipswich",
      ],
      Wales: [
        "Pontypridd",
        "Swansea",
        "Aberystwyth",
        "Cardiff",
        "Carmarthen",
        "Bangor",
        "Newport",
        "Wrexham",
        "Lampeter",
      ],
      "North West England": [
        "Salford",
        "Bolton",
        "Liverpool",
        "Manchester",
        "Lancaster",
        "Carlisle",
        "Chester",
        "Ormskirk",
        "Preston",
      ],
      London: [
        "London",
        "Kingston upon Thames",
        "Uxbridge",
        "Ealing",
        "Twickenham",
      ],
      Scotland: [
        "Glasgow",
        "Aberdeen",
        "Dundee",
        "Edinburgh",
        "St Andrews",
        "Stirling",
        "Inverness",
        "Kirkwall",
        "Musselburgh",
        "Oban",
        "Ayr",
        "Perth",
      ],
      "East Midlands": [
        "Nottingham",
        "Leicester",
        "Loughborough",
        "Derby",
        "Northampton",
      ],
      "South West England": [
        "Bristol",
        "Bath",
        "Cheltenham",
        "Plymouth",
        "Poole",
        "Falmouth",
        "Gloucester",
        "Exeter",
        "Cirencester",
      ],
      "West Midlands": [
        "Birmingham",
        "Coventry",
        "Stoke-on-Trent",
        "Keele",
        "Wolverhampton",
        "Worcester",
      ],
      "South East England": [
        "Southampton",
        "Guildford",
        "Brighton",
        "Oxford",
        "Canterbury",
        "Portsmouth",
        "Egham",
        "Reading",
        "Buckingham",
        "Farnham",
        "Chichester",
        "Winchester",
      ],
      "North East England": [
        "Newcastle upon Tyne",
        "Middlesbrough",
        "Durham",
        "Sunderland",
      ],
      "Northern Ireland": ["Coleraine", "Belfast"],
      England: [
        "Cambridge",
        "Canterbury",
        "Colchester",
        "Manchester",
        "London",
        "Liverpool",
        "Birmingham",
        "Newcastle upon Tyne",
        "Nottingham",
        "Oxford",
        "Norwich",
        "Keele",
        "Brighton",
        "Durham",
        "Sheffield",
        "Southampton",
        "Bradford",
        "Hertford",
        "Chester",
        "Bristol",
        "Exeter",
        "York",
        "Cranfield",
        "Bournemouth",
        "Cirencester",
        "Reading",
        "Lancaster",
        "Lincoln",
        "Loughborough",
        "Winchester",
        "Middlesbrough",
        "Leeds",
        "Coventry",
        "Salford",
        "Guildford",
        "Derby",
        "Hatfield",
        "Preston",
        "Huddersfield",
        "Sunderland",
        "Ipswich",
        "Bath",
        "Luton",
        "Worcester",
        "Cheltenham",
        "Hull",
        "Falmouth",
        "Abbey Wood",
        "Plymouth",
        "Portsmouth",
        "Wolverhampton",
        "Chatham",
        "Leicester",
        "Northampton",
        "Gloucester",
        "Bolton",
        "Grantham",
        "City of London",
        "Carlisle",
        "Stoke-on-Trent",
        "Buckingham",
        "Walsall",
        "Penryn",
        "Chichester",
        "Buxton",
        "Bedford",
        "Chelmsford",
        "Shrewsbury",
        "Newport",
        "Lambeth",
        "Swindon",
      ],
      "N Ireland": ["Belfast", "Coleraine"],
    },
  };
  export const filterOptions = {
    courses: [
      {
        type: "country",
        label: "Country",
        options: countryList?.map((item) => ({
          name: item,
          value: item,
        })),
        selectedType: "multi",
        searchbox: false,
      },
      {
        type: "intake",
        label: "Start date",
        options: [
          { name: "January-March", value: "0" },
          { name: "April-June", value: "1" },
          { name: "July-September", value: "2" },
          { name: "October-December", value: "3" },
        ],
        selectedType: "single",
        searchbox: false,
      },
      {
        type: "openNow",
        label: "Open Now",
        options: [{ name: "Active courses", value: "" }],
        selectedType: "single",
        searchbox: false,
      },
      {
        type: "stem",
        label: "Stem",
        options: [{ name: "STEM Courses", value: "" }],
        selectedType: "single",
        searchbox: false,
      },
      {
        type: "type",
        label: "Type",
  
        options: [
          { value: "public", name: "Public" },
          { value: "private", name: "Private" },
        ],
        selectedType: "multi",
        searchbox: false,
      },
      {
        type: "studyMode",
        label: "Study Mode",
        options: [
          { name: "On Campus", value: "On Campus" },
          { name: "Online", value: "Online" },
          { name: "Blended", value: "Blended" },
        ],
        selectedType: "multi",
        searchbox: false,
      },
      {
        type: "studyLevel",
        label: "Study Level",
        options: degreeType?.map((item) => ({
          name: item,
          value: item,
        })),
        selectedType: "multi",
        searchbox: true,
      },
      {
        type: "budget",
        label: "Budget",
        options: [],
        selectedType: "multi",
        customContainer: {
          name: "budget",
          data: [],
        },
        searchbox: false,
      },
      {
        type: "state",
        label: "State",
        options: [],
        selectedType: "multi",
        customContainer: {
          name: "state",
          data: [],
        },
        searchbox: false,
      },
      {
        type: "city",
        label: "City",
        options: [],
        selectedType: "multi",
        customContainer: {
          name: "city",
          data: [],
        },
        searchbox: false,
      },
      {
        type: "subDiscipline",
        label: "Sub Discipline",
  
        options: subDisciplines?.map((item) => ({
          name: item,
          value: item,
        })),
        selectedType: "multi",
        searchbox: true,
      },
      {
        type: "AcademicTestName",
        label: "Academic Test Name",
  
        options: [],
        selectedType: "multi",
        customContainer: {
          name: "academicFilter",
          data: [],
        },
        searchbox: false,
      },
      {
        type: "LanguageTestName",
        label: "Language Test Name",
        options: [],
        selectedType: "multi",
        customContainer: {
          name: "languageFilter",
          data: [],
        },
        searchbox: false,
      },
    ],
    universities: [
      {
        type: "country",
        label: "Country",
  
        options: countryList?.map((item) => ({
          name: item,
          value: item,
        })),
        selectedType: "multi",
        searchbox: false,
      },
      {
        type: "state",
        label: "State",
  
        options: [],
        selectedType: "multi",
        customContainer: {
          name: "state",
          data: [],
        },
        searchbox: false,
      },
      {
        type: "city",
        label: "City",
  
        options: [],
        selectedType: "multi",
        customContainer: {
          name: "city",
          data: [],
        },
        searchbox: false,
      },
      {
        type: "type",
        label: "Type",
        options: [
          { value: "public", name: "Public" },
          { value: "private", name: "Private" },
        ],
        selectedType: "multi",
        searchbox: false,
      },
      {
        type: "rating",
        label: "Rating",
  
        options: [
          { value: "6", name: "6" },
          { value: "8", name: "8" },
        ],
        selectedType: "single",
        searchbox: false,
      },
    ],
  };
  export const quickOptions = {
  courses: [
    // {
    //   type: "openNow",
    //   label:"Open",
    //   options: [{ name: "Active courses", value: "" }],
    //   searchbox: false,
    //   selectedType: "single",
    // },
      // {
      //   type: "stemDetails.stem",
      //   label: "STEM",
      //   options: [{ name: "STEM", value: true}],
      //   selectedType: "single",
      //   searchbox: false,
      // },
    

      {
        type: "STEM",
        label: "STEM",
        options: [{ name: "STEM", value: true }],
        selectedType: "single",
        searchbox: false,
      },
      {
        type: "waiver",
        label: "Fee Waiver",
        options: [{ name: "Fee Waiver", value: true}],
        selectedType: "single",
        searchbox: false,
      },
      
    {
      type: "GRE",  
      label: "No GRE",
      options: [
        {
          name: "No GRE", value:false
        },

      ],
      searchbox: false,
      selectedType: "single",
    },
    {
      type: "GMAT",
      label: "No GMAT",
      options: [
        {
          name: "No GMAT", value: false
        },

      ],
      selectedType: "single",
      searchbox: false,

    },
    {
      type: "Duolingo",
      label: "Duolingo acceptable",
      options: [
        {
          name: "Duolingo acceptable", value:true
        },

      ],
      selectedType: "single",
      searchbox: false,

    },

    // {
    //   type: "LanguageTestName",
    //   options: [
    //     {name:"TOEFL",value:"TOEFL"},
    //     {name:"IELTS",value:"IELTS"},
    //     {name:"PTE",value:"PTE"},
    //     {name:"DET",value:"DET"},

    //   ] ,
    //   selectedType: "multi",
    // },
    // {
    //   type: "budget",
    //   options: [],
    //   selectedType: "single",
    // },

  ],
  universities: [
  ],
};
  
  export const languages = [
    "English",
    "Telugu",
    "Hindi",
    "Afrikaans",
    "Akan",
    "Albanian",
    "Amharic",
    "Arabic",
    "Armenian",
    "Assamese",
    "Aymara",
    "Azerbaijani",
    "Basque",
    "Belarusian",
    "Bengali",
    "Berber",
    "Bislama",
    "Bosnian",
    "Bulgarian",
    "Burmese",
    "Cantonese",
    "Catalan",
    "Croatian",
    "Dari",
    "Dioula",
    "Dutch",
    "Dzongkha",
    "Ewe",
    "Fijian",
    "Filipino (Tagalog)",
    "French",
    "Galician",
    "German",
    "Gilbertese",
    "Greek",
    "Guaraní",
    "Gujarati",
    "Haitian Creole",
    "Hausa",
    "Hebrew",
    "Hiri Motu",
    "Hungarian",
    "Icelandic",
    "Igbo",
    "Indonesian",
    "Irish",
    "Italian",
    "Japanese",
    "Kannada",
    "Kashmiri",
    "Kazakh",
    "Kikongo",
    "Konkani",
    "Korean",
    "Kurdish",
    "Latvian",
    "Lingala",
    "Lithuanian",
    "Luxembourgish",
    "Maithili",
    "Malay",
    "Malayalam",
    "Maltese",
    "Mandarin Chinese",
    "Manipuri",
    "Māori",
    "Marathi",
    "Marshallese",
    "Moore",
    "Nepali",
    "Norwegian",
    "Oromo",
    "Pashto",
    "Persian (Farsi)",
    "Pijin",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Quechua",
    "Romanian",
    "Romansh",
    "Russian",
    "Samoan",
    "Sanskrit",
    "Scottish Gaelic",
    "Serbian",
    "Sesotho",
    "Setswana",
    "Sindhi",
    "Sinhala",
    "Slovak",
    "Slovenian",
    "Spanish (Castilian)",
    "Swahili",
    "Swedish",
    "Tamil",
    "Thai",
    "Tibetan",
    "Tigrinya",
    "Tok Pisin",
    "Tongan",
    "Uighur",
    "Urdu",
    "Vietnamese",
    "Welsh",
    "Xhosa",
    "Yoruba",
    "Zulu"
  ];
  
  export const boards = [
    "Central Board of Secondary Education (CBSE)", 
    "Indian Certificate of Secondary Education (ICSE)", 
    "International Baccalaureate (IB)", 
    "National Institute of Open Schooling (NIOS)", 
    "All India Senior School Certificate Examination (AISSCE)", 
  ]
  
  export const filterFacets = {
  country: { label: "Country", icon: Images.country, selectedType: "multi", searchbox: false },
  state: { label: "State", icon: Images.state, selectedType: "multi", searchbox: true },
  city: { label: "City", icon: Images.city, selectedType: "multi", searchbox: true },
  // discipline: { label: "Discipline", icon: Images.discipline, selectedType: "multi", searchbox: true },
  subDiscipline: { label: "Courses", icon: Images.subDiscipline, selectedType: "multi", searchbox: true },
  type: { label: "Type", icon: Images.universityType, selectedType: "multi", searchbox: false },
  studyMode: { label: "Study Mode", icon: Images.studyMode, selectedType: "multi", searchbox: false },
  courseStartingMonth: { label: "Start Date", icon: Images.startDate, selectedType: "single", searchbox: false },
  GRE: { label: "GRE Acceptance", icon: Images.studyMode, selectedType: "single", searchbox: false },
  GMAT: { label: "GMAT Acceptance", icon: Images.studyMode, selectedType: "single", searchbox: false },
  TOEFL: { label: "TOEFL Acceptance", icon: Images.studyMode, selectedType: "single", searchbox: false },
  Duolingo: { label: "Duolingo Acceptance", icon: Images.studyMode, selectedType: "single", searchbox: false },
  IELTS: { label: "IELTS Acceptance", icon: Images.studyMode, selectedType: "single", searchbox: false },
  PTE: { label: "PTE Acceptance", icon: Images.studyMode, selectedType: "single", searchbox: false },
  featured: { label: "Featured", icon: Images.universityType, selectedType: "single", searchbox: false },


};